// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/demand_forecast_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { AreaCode } from "../../bfftypes/v1/area_pb";
import { file_bfftypes_v1_area } from "../../bfftypes/v1/area_pb";
import type { AggregationScope } from "./demand_confirm_record_model_pb";
import { file_bffuser_v1_demand_confirm_record_model } from "./demand_confirm_record_model_pb";
import type { GateCloseFrontier } from "./gate_close_model_pb";
import { file_bffuser_v1_gate_close_model } from "./gate_close_model_pb";
import type { SingularDayCategory } from "./singular_day_model_pb";
import { file_bffuser_v1_singular_day_model } from "./singular_day_model_pb";
import type { WeatherSource } from "./weather_forecast_model_pb";
import { file_bffuser_v1_weather_forecast_model } from "./weather_forecast_model_pb";
import type { WorkflowSection } from "./workflow_template_model_pb";
import { file_bffuser_v1_workflow_template_model } from "./workflow_template_model_pb";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Date } from "../../google/type/date_pb";
import { file_google_type_date } from "../../google/type/date_pb";
import type { Decimal } from "../../google/type/decimal_pb";
import { file_google_type_decimal } from "../../google/type/decimal_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/demand_forecast_service.proto.
 */
export const file_bffuser_v1_demand_forecast_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_bfftypes_v1_area, file_bffuser_v1_demand_confirm_record_model, file_bffuser_v1_gate_close_model, file_bffuser_v1_singular_day_model, file_bffuser_v1_weather_forecast_model, file_bffuser_v1_workflow_template_model, file_buf_validate_validate, file_google_protobuf_timestamp, file_google_type_date, file_google_type_decimal]);

/**
 * GetDemandForecastDailyRequest identifies the aggregated page to retrieve.
 * scope / scope_identifier are absent;
 * the BFF handler returns all retailer drafts for the case.
 *
 * @generated from message bffuser.v1.GetDemandForecastDailyRequest
 */
export type GetDemandForecastDailyRequest = Message<"bffuser.v1.GetDemandForecastDailyRequest"> & {
  /**
   * case_id is the WorkflowCase identifier (UUID).
   *
   * @generated from field: string case_id = 1;
   */
  caseId: string;

  /**
   * area_code identifies the electricity supply region. Must not be UNSPECIFIED.
   *
   * @generated from field: bfftypes.v1.AreaCode area_code = 2;
   */
  areaCode: AreaCode;

  /**
   * section is the planning horizon (断面). Must not be UNSPECIFIED.
   *
   * @generated from field: bffuser.v1.WorkflowSection section = 3;
   */
  section: WorkflowSection;

  /**
   * target_date is the forecast date. Required.
   *
   * @generated from field: google.type.Date target_date = 4;
   */
  targetDate?: Date;

  /**
   * past_actual_dates lists the calendar dates for which historical actual
   * demand values should be returned in the page's past_actuals field.
   * Maximum 5 dates (AC-01/AC-02, demand-forecast-daily-spec-align: relaxed
   * from the prior max 3). When absent, the backend uses its default
   * selection.
   *
   * @generated from field: repeated google.type.Date past_actual_dates = 6;
   */
  pastActualDates: Date[];

  /**
   * location_name overrides the weather-forecast observation point for this
   * request's display only (画面内一時切替, AC-DFC-008a/008b). When absent
   * (or empty) the backend resolves the organization's common setting for
   * the area (existing behavior, unchanged). Must be one of the area's
   * system-fixed candidate points (WeatherForecastPointCatalog) or the
   * backend rejects with INVALID_ARGUMENT. The override affects ONLY the
   * page's weather display (weather bar / chart temperature-dewpoint /
   * legend / weather icon / observation_point_name) — it is never used to
   * resolve the demand forecast values, similar-day search, or confirm
   * (Cross-slice Invariant, weather-point-in-screen-temp-switch design D2).
   * Not persisted: this is an ephemeral, per-request override (design D4).
   *
   * @generated from field: optional string location_name = 7;
   */
  locationName?: string;

  /**
   * supports_unattributed identifies clients that render the unattributed
   * breakdown. Legacy clients are rejected when it has a non-zero value.
   *
   * @generated from field: bool supports_unattributed = 9;
   */
  supportsUnattributed: boolean;
};

/**
 * Describes the message bffuser.v1.GetDemandForecastDailyRequest.
 * Use `create(GetDemandForecastDailyRequestSchema)` to create a new message.
 */
export const GetDemandForecastDailyRequestSchema: GenMessage<GetDemandForecastDailyRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_demand_forecast_service, 0);

/**
 * GetDemandForecastDailyResponse wraps the full aggregated page.
 *
 * @generated from message bffuser.v1.GetDemandForecastDailyResponse
 */
export type GetDemandForecastDailyResponse = Message<"bffuser.v1.GetDemandForecastDailyResponse"> & {
  /**
   * page carries the aggregated editing page for the requested context.
   *
   * @generated from field: bffuser.v1.DemandForecastDailyPage page = 1;
   */
  page?: DemandForecastDailyPage;

  /**
   * weather_status indicates whether the weather data fetch succeeded.
   * Absent when the status is not determined.
   *
   * @generated from field: optional bffuser.v1.AuxiliaryDataStatus weather_status = 2;
   */
  weatherStatus?: AuxiliaryDataStatus;

  /**
   * past_actuals_status indicates whether the past actuals fetch succeeded.
   * Absent when the status is not determined.
   *
   * @generated from field: optional bffuser.v1.AuxiliaryDataStatus past_actuals_status = 4;
   */
  pastActualsStatus?: AuxiliaryDataStatus;
};

/**
 * Describes the message bffuser.v1.GetDemandForecastDailyResponse.
 * Use `create(GetDemandForecastDailyResponseSchema)` to create a new message.
 */
export const GetDemandForecastDailyResponseSchema: GenMessage<GetDemandForecastDailyResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_demand_forecast_service, 1);

/**
 * SaveDemandForecastDraftRequest carries the full 48-slot state for a single
 * retailer to persist. All slot arrays must have exactly 48 elements.
 * organization_id is intentionally absent; the BFF handler resolves it from
 * the eauth session. scope is fixed to RETAIL by the BFF handler.
 *
 * @generated from message bffuser.v1.SaveDemandForecastDraftRequest
 */
export type SaveDemandForecastDraftRequest = Message<"bffuser.v1.SaveDemandForecastDraftRequest"> & {
  /**
   * case_id is the WorkflowCase identifier (UUID).
   *
   * @generated from field: string case_id = 1;
   */
  caseId: string;

  /**
   * area_code identifies the electricity supply region.
   *
   * @generated from field: bfftypes.v1.AreaCode area_code = 2;
   */
  areaCode: AreaCode;

  /**
   * section is the planning horizon. Must not be UNSPECIFIED.
   *
   * @generated from field: bffuser.v1.WorkflowSection section = 3;
   */
  section: WorkflowSection;

  /**
   * target_date is the forecast date. Required.
   *
   * @generated from field: google.type.Date target_date = 4;
   */
  targetDate?: Date;

  /**
   * retailer_business_cd is the retailer's 4-char OCCTO business code
   * (= scope_identifier passed to internalapi, mock-app SoT
   * DemandConfirmRecord.cs:69 RetailerLevel FK -> BusinessMaster.BusinessCd).
   *
   * @generated from field: string retailer_business_cd = 5;
   */
  retailerBusinessCd: string;

  /**
   * forecast_slots contains the current demand forecast values after any
   * manual edits. Must have exactly 48 elements (scale: see SlotValue doc).
   *
   * @generated from field: repeated bffuser.v1.SlotValue forecast_slots = 6;
   */
  forecastSlots: SlotValue[];

  /**
   * provider_slots contains the provider-sourced values before manual edits
   * (取り込み原値). Must have exactly 48 elements.
   *
   * @generated from field: repeated bffuser.v1.SlotValue provider_slots = 7;
   */
  providerSlots: SlotValue[];

  /**
   * manual_edit_komas lists the 1-indexed koma numbers that have been
   * manually edited relative to the provider source.
   *
   * @generated from field: repeated int32 manual_edit_komas = 8;
   */
  manualEditKomas: number[];

  /**
   * provider is the data source classification. Must not be UNSPECIFIED.
   *
   * @generated from field: bffuser.v1.DemandForecastProvider provider = 9;
   */
  provider: DemandForecastProvider;

  /**
   * provider_other is a free-text description when
   * provider = DEMAND_FORECAST_PROVIDER_OTHER.
   *
   * @generated from field: optional string provider_other = 10;
   */
  providerOther?: string;

  /**
   * provider_label is a frozen display name snapshot of the provider.
   *
   * @generated from field: optional string provider_label = 11;
   */
  providerLabel?: string;

  /**
   * expected_updated_at is the optimistic-lock baseline. Omit on the first
   * save; required on subsequent saves. The server returns ABORTED when the
   * value does not match the current updated_at of the draft record.
   * Clients must hold this value as a proto Timestamp (not converted to Date)
   * to preserve microsecond precision.
   *
   * @generated from field: optional google.protobuf.Timestamp expected_updated_at = 12;
   */
  expectedUpdatedAt?: Timestamp;

  /**
   * unattributed selects the 帰属不明 breakdown instead of a retailer.
   *
   * @generated from field: bool unattributed = 13;
   */
  unattributed: boolean;

  /**
   * supports_unattributed identifies clients that render the unattributed
   * breakdown. Legacy clients are rejected when it has a non-zero value.
   *
   * @generated from field: bool supports_unattributed = 15;
   */
  supportsUnattributed: boolean;
};

/**
 * Describes the message bffuser.v1.SaveDemandForecastDraftRequest.
 * Use `create(SaveDemandForecastDraftRequestSchema)` to create a new message.
 */
export const SaveDemandForecastDraftRequestSchema: GenMessage<SaveDemandForecastDraftRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_demand_forecast_service, 2);

/**
 * SaveDemandForecastDraftResponse returns the new updated_at timestamp so
 * the client can use it as the expected_updated_at for subsequent Save or
 * Confirm requests (optimistic-lock round-trip). Clients must hold this value
 * as a proto Timestamp (not converted to Date) to preserve microsecond
 * precision.
 *
 * @generated from message bffuser.v1.SaveDemandForecastDraftResponse
 */
export type SaveDemandForecastDraftResponse = Message<"bffuser.v1.SaveDemandForecastDraftResponse"> & {
  /**
   * updated_at is the updated_at timestamp of the newly saved draft.
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 1;
   */
  updatedAt?: Timestamp;

  /**
   * trend_preview is the trend reflection preview for the same-day section,
   * recomputed after the draft is saved. Absent for other sections or when
   * fewer than 2 actual data points are available.
   *
   * @generated from field: optional bffuser.v1.TrendReflectionPreview trend_preview = 2;
   */
  trendPreview?: TrendReflectionPreview;
};

/**
 * Describes the message bffuser.v1.SaveDemandForecastDraftResponse.
 * Use `create(SaveDemandForecastDraftResponseSchema)` to create a new message.
 */
export const SaveDemandForecastDraftResponseSchema: GenMessage<SaveDemandForecastDraftResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_demand_forecast_service, 3);

/**
 * ConfirmDemandForecastRequest instructs the backend to batch-freeze the
 * saved drafts for all specified retailers as business-confirmed demand records.
 * organization_id and acting_member_id are intentionally absent; the BFF
 * handler resolves both from the eauth session (acting_member_id becomes the
 * confirm record's confirmed_by / 確定者, #6538).
 *
 * @generated from message bffuser.v1.ConfirmDemandForecastRequest
 */
export type ConfirmDemandForecastRequest = Message<"bffuser.v1.ConfirmDemandForecastRequest"> & {
  /**
   * case_id is the WorkflowCase identifier (UUID).
   *
   * @generated from field: string case_id = 1;
   */
  caseId: string;

  /**
   * area_code identifies the electricity supply region.
   *
   * @generated from field: bfftypes.v1.AreaCode area_code = 2;
   */
  areaCode: AreaCode;

  /**
   * section is the planning horizon. Must not be UNSPECIFIED.
   *
   * @generated from field: bffuser.v1.WorkflowSection section = 3;
   */
  section: WorkflowSection;

  /**
   * target_date is the forecast date. Required.
   *
   * @generated from field: google.type.Date target_date = 4;
   */
  targetDate?: Date;

  /**
   * targets lists the per-retailer confirmation targets with per-retailer
   * optimistic-lock baselines. At least one target is required.
   *
   * @generated from field: repeated bffuser.v1.RetailerConfirmTarget targets = 5;
   */
  targets: RetailerConfirmTarget[];

  /**
   * curve_rationale is an optional free-text rationale for the curve shape
   * chosen (確定ダイアログ入力項目). Max 100 characters when set.
   *
   * @generated from field: optional string curve_rationale = 6;
   */
  curveRationale?: string;

  /**
   * max_power_rationale is an optional free-text rationale for the peak
   * demand estimate. Max 100 characters when set.
   *
   * @generated from field: optional string max_power_rationale = 7;
   */
  maxPowerRationale?: string;

  /**
   * min_power_rationale is an optional free-text rationale for the trough
   * demand estimate. Max 100 characters when set.
   *
   * @generated from field: optional string min_power_rationale = 8;
   */
  minPowerRationale?: string;

  /**
   * numerical_basis is an optional free-text note on the numerical basis of
   * the forecast. Max 100 characters when set.
   *
   * @generated from field: optional string numerical_basis = 9;
   */
  numericalBasis?: string;

  /**
   * free_note is an optional free-text note for any other remarks. Max 100
   * characters when set.
   *
   * @generated from field: optional string free_note = 10;
   */
  freeNote?: string;
};

/**
 * Describes the message bffuser.v1.ConfirmDemandForecastRequest.
 * Use `create(ConfirmDemandForecastRequestSchema)` to create a new message.
 */
export const ConfirmDemandForecastRequestSchema: GenMessage<ConfirmDemandForecastRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_demand_forecast_service, 4);

/**
 * RetailerConfirmTarget carries the per-retailer optimistic-lock baseline
 * for a batch confirm operation. The repeated message form is used instead of
 * a map<retailer_business_cd, Timestamp> because proto map values cannot be
 * message types and map ordering is not guaranteed.
 *
 * @generated from message bffuser.v1.RetailerConfirmTarget
 */
export type RetailerConfirmTarget = Message<"bffuser.v1.RetailerConfirmTarget"> & {
  /**
   * retailer_business_cd is the retailer's 4-char OCCTO business code. Must
   * not be empty.
   *
   * @generated from field: string retailer_business_cd = 1;
   */
  retailerBusinessCd: string;

  /**
   * expected_updated_at is the optimistic-lock baseline for this retailer's
   * draft. Required. Must match the updated_at of the draft to be confirmed;
   * the server returns ABORTED when they differ.
   *
   * @generated from field: google.protobuf.Timestamp expected_updated_at = 2;
   */
  expectedUpdatedAt?: Timestamp;
};

/**
 * Describes the message bffuser.v1.RetailerConfirmTarget.
 * Use `create(RetailerConfirmTargetSchema)` to create a new message.
 */
export const RetailerConfirmTargetSchema: GenMessage<RetailerConfirmTarget> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_demand_forecast_service, 5);

/**
 * ConfirmDemandForecastResponse carries the references to the newly created
 * confirm records (one per retailer + one BG-total).
 *
 * @generated from message bffuser.v1.ConfirmDemandForecastResponse
 */
export type ConfirmDemandForecastResponse = Message<"bffuser.v1.ConfirmDemandForecastResponse"> & {
  /**
   * records lists the created confirm record references.
   *
   * @generated from field: repeated bffuser.v1.ConfirmedRecordRef records = 1;
   */
  records: ConfirmedRecordRef[];

  /**
   * confirmed_at is the server-authoritative 確定日時 of the BG-total confirm
   * record (new on a fresh confirm, existing on an idempotent re-confirm). The
   * frontend uses it for the 確定完了 表示 instead of a client clock.
   *
   * @generated from field: google.protobuf.Timestamp confirmed_at = 2;
   */
  confirmedAt?: Timestamp;
};

/**
 * Describes the message bffuser.v1.ConfirmDemandForecastResponse.
 * Use `create(ConfirmDemandForecastResponseSchema)` to create a new message.
 */
export const ConfirmDemandForecastResponseSchema: GenMessage<ConfirmDemandForecastResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_demand_forecast_service, 6);

/**
 * ConfirmedRecordRef is a reference to a single newly created confirm record,
 * carrying the frozen peak-demand values computed at confirmation time.
 *
 * @generated from message bffuser.v1.ConfirmedRecordRef
 */
export type ConfirmedRecordRef = Message<"bffuser.v1.ConfirmedRecordRef"> & {
  /**
   * confirm_record_id is the UUID of the newly created DemandConfirmRecord.
   *
   * @generated from field: string confirm_record_id = 1;
   */
  confirmRecordId: string;

  /**
   * scope classifies the aggregation unit of this record (RETAIL or BG_TOTAL).
   * Uses bffuser.v1.AggregationScope defined in demand_confirm_record_model.proto.
   *
   * @generated from field: bffuser.v1.AggregationScope scope = 2;
   */
  scope: AggregationScope;

  /**
   * scope_identifier is the retailer BusinessCd (4-char) for RETAIL records.
   * Absent for BG_TOTAL records.
   *
   * @generated from field: optional string scope_identifier = 3;
   */
  scopeIdentifier?: string;

  /**
   * max_power is the peak demand slot value computed at confirmation time
   * (送電端 MWh).
   *
   * @generated from field: google.type.Decimal max_power = 4;
   */
  maxPower?: Decimal;

  /**
   * max_power_koma is the 1-indexed koma number at which max_power occurs.
   *
   * @generated from field: int32 max_power_koma = 5;
   */
  maxPowerKoma: number;
};

/**
 * Describes the message bffuser.v1.ConfirmedRecordRef.
 * Use `create(ConfirmedRecordRefSchema)` to create a new message.
 */
export const ConfirmedRecordRefSchema: GenMessage<ConfirmedRecordRef> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_demand_forecast_service, 7);

/**
 * DemandForecastDailyPage is the full aggregated editing page returned by
 * GetDemandForecastDaily. It carries all retailer drafts for the given
 * (case_id, area_code, section, target_date), the read-only BG-total slot
 * series (= Σ retailers), and weather / actuals comparison series.
 *
 * Proto v1 破壊的削除（#4072）: provider_forecasts (8) / available_providers
 * (12) / 既存の reserved 10 (confirm_comparisons) / reserved 13 (scatter) を
 * reserved なしで削除。根拠: 未リリースのため wire 互換の考慮が不要
 * (ユーザー判断 2026-07-28)。
 * buf.yaml breaking(FILE) からの意図的逸脱。reserved 10 / 13 も同方針（§4
 * Q8/Q11）: 未リリース一律不要化 — 用途消滅番号の reserved 維持と破壊的削除の
 * 混在は番号管理方針を矛盾させる。繰延: reserved 10 候補 slice 4 は #3165 で
 * 再設計予定、reserved 13 は spec 決定 C / issue #2321 で削除確定。
 *
 * dewpoint_forecast_slots (旧 18) も同方針で reserved なしで削除済み (spec
 * #4290 改訂 2026-08-14: 露点は実績側のみ表示、予測露点は算出・表示しない。
 * JMA 公開予報が湿度を配信しないため常に空スロットだった = 撤去による観測値の
 * 消失なし)。dewpoint_actual_slots (19) は不変。
 *
 * @generated from message bffuser.v1.DemandForecastDailyPage
 */
export type DemandForecastDailyPage = Message<"bffuser.v1.DemandForecastDailyPage"> & {
  /**
   * section is the planning horizon for this page.
   *
   * @generated from field: bffuser.v1.WorkflowSection section = 1;
   */
  section: WorkflowSection;

  /**
   * target_date is the date for which the forecast applies.
   *
   * @generated from field: google.type.Date target_date = 2;
   */
  targetDate?: Date;

  /**
   * area_code identifies the electricity supply region.
   *
   * @generated from field: bfftypes.v1.AreaCode area_code = 3;
   */
  areaCode: AreaCode;

  /**
   * gc_koma is the last gate-closed koma (1-indexed), computed by the
   * backend from the current JST time. 0 when the gate is not yet closed.
   *
   * @generated from field: int32 gc_koma = 4;
   */
  gcKoma: number;

  /**
   * current_koma is the currently active koma (1-indexed), computed from
   * the current JST time.
   *
   * @generated from field: int32 current_koma = 5;
   */
  currentKoma: number;

  /**
   * retailers lists the per-retailer draft state for all retail BGs under
   * the case.
   *
   * @generated from field: repeated bffuser.v1.RetailerDraft retailers = 6;
   */
  retailers: RetailerDraft[];

  /**
   * bg_total_slots is the read-only BG-total slot series (= Σ retailers +
   * unattributed).
   * Always 48 elements. Computed by the backend; must not be written back to
   * SaveDemandForecastDraft.
   *
   * @generated from field: repeated bffuser.v1.SlotValue bg_total_slots = 7;
   */
  bgTotalSlots: SlotValue[];

  /**
   * past_actuals lists up to three days of historical actual values for
   * comparison display (過去実績).
   *
   * @generated from field: repeated bffuser.v1.PastActual past_actuals = 9;
   */
  pastActuals: PastActual[];

  /**
   * weather carries the weather bar data (気象情報バー). Skeleton only.
   *
   * @generated from field: optional bffuser.v1.ForecastWeatherBar weather = 11;
   */
  weather?: ForecastWeatherBar;

  /**
   * trend_preview is the trend reflection preview for the same-day section.
   * Absent for other sections or when fewer than 2 actual data points are
   * available.
   *
   * @generated from field: optional bffuser.v1.TrendReflectionPreview trend_preview = 14;
   */
  trendPreview?: TrendReflectionPreview;

  /**
   * today_actual_slots is the per-koma actual demand for the current day
   * (当日実績需要, scale: see SlotValue doc). Populated for
   * WORKFLOW_SECTION_TODAY only; empty for other sections (actual data not
   * yet available). Maximum 48 elements.
   *
   * @generated from field: repeated bffuser.v1.SlotValue today_actual_slots = 15;
   */
  todayActualSlots: SlotValue[];

  /**
   * temperature_forecast_slots is the per-koma temperature forecast
   * (予報気温) for all sections. Only the komas of the published on-the-hour
   * points carry a value. Maximum 54 elements; 対象日が明日以前は 54 要素
   * (index 48 = 対象日の 24 時の点), それ以降は 48 要素.
   *
   * @generated from field: repeated bffuser.v1.SlotValue temperature_forecast_slots = 16;
   */
  temperatureForecastSlots: SlotValue[];

  /**
   * temperature_actual_slots is the per-koma observed temperature
   * (実績気温). Populated when target_date is today or a past date (JST) and
   * observations are available (spec AC-DFD-002a, #6933); empty for future
   * dates. 48 elements for the target day; when the day after target_date
   * has an observation at 0:00〜2:30 it carries 54 elements and index
   * 48..53 is that next-day chart extension (index 48 = 翌日 0:00, spec
   * AC-DFD-006a-2). Missing observations stay empty.
   *
   * @generated from field: repeated bffuser.v1.SlotValue temperature_actual_slots = 17;
   */
  temperatureActualSlots: SlotValue[];

  /**
   * dewpoint_actual_slots is the per-koma observed dewpoint temperature
   * (実績露点). Same length and index layout as temperature_actual_slots
   * (index 48..53 = 翌日 0:00〜2:30 when present).
   *
   * @generated from field: repeated bffuser.v1.SlotValue dewpoint_actual_slots = 19;
   */
  dewpointActualSlots: SlotValue[];

  /**
   * loss_rate_breakdown is the loss rate breakdown by voltage class for the
   * selected area (損失率内訳, AC-DFC-010). Absent when no LossRateSetting
   * is configured for the area.
   *
   * @generated from field: optional bffuser.v1.LossRateBreakdown loss_rate_breakdown = 20;
   */
  lossRateBreakdown?: LossRateBreakdown;

  /**
   * prev_day_actual_slots is the built-in chart series for the previous
   * day's actual demand (target_date - 1, 前日実績, design
   * demand/forecast-today.html L2854/L2954). This is a built-in chart series
   * independent from the operator-selected past_actuals field (過去実績
   * スロット). Empty when no actual record exists for the previous day.
   * Maximum 48 elements.
   *
   * @generated from field: repeated bffuser.v1.SlotValue prev_day_actual_slots = 21;
   */
  prevDayActualSlots: SlotValue[];

  /**
   * observation_point_name is the displayed weather observation point name
   * (design demand/forecast-today.html L793), independent of whether weather
   * forecast data itself is available. Its source depends on the screen state
   * (weather-point-in-screen-temp-switch design D7/D8):
   *   - live / editable screen: the area-level weather forecast point master
   *     (外部データサービス > 気象 > エリア別気象予測地点). Empty string when
   *     the area has no configured observation point.
   *   - WHILE the operator has a screen-local temporary override active (画面内
   *     一時切替, AC-DFC-008a; non-confirmed sections only): the overridden
   *     point, not the master value.
   *   - WHILE the section is confirmed (business-confirmed BG_TOTAL, read-only
   *     recap, AC-DFC-008c): the point captured in the confirm-time weather
   *     snapshot, pinned — a temporary override does NOT apply and it does NOT
   *     revert to the current master or drift to any other current-state value
   *     even if the master changes later (so there is no override-vs-confirmed
   *     precedence to resolve: confirmed always wins). Empty string when the
   *     snapshot itself carries no station name (rather than falling back to
   *     the master or the override). Exception: if the confirm-time snapshot
   *     lookup/read fails, the whole weather strip degrades to the live view
   *     (an error fallback), so this pinning describes the normal confirmed
   *     path.
   * On today / past target dates, the observed (AMeDAS) station name can win over the
   * above ONLY when no temporary override is active AND the name is not pinned
   * (D7) — it never applies to the confirmed case above, which stays pinned.
   * Unlike ForecastWeatherBar.observation_point_name (which is only populated
   * when a weather snapshot exists), this field is always populated when its
   * source (per the branches above) is itself populated.
   *
   * @generated from field: string observation_point_name = 22;
   */
  observationPointName: string;

  /**
   * target_date_day_type is the 4-category classification of target_date
   * (spec §8, AC-036: 平日 / 土曜 / 休日（日祝）/ 特異日). Always populated by
   * the backend: a lookup failure gracefully degrades to the non-holiday /
   * non-singular branch rather than leaving this field UNSPECIFIED. No
   * protovalidate rule: this field allows the proto3 zero value as a
   * defensive fallback for server-side drift, unlike
   * SimilarDayCandidate.weekday_category.
   *
   * @generated from field: bffuser.v1.DayType target_date_day_type = 23;
   */
  targetDateDayType: DayType;

  /**
   * singular_day_name is the master-registered name of the singular day
   * (特異日名, spec §8 AC-036a). Populated iff target_date_day_type is
   * DAY_TYPE_SINGULAR. Empty string otherwise.
   *
   * @generated from field: string singular_day_name = 24;
   */
  singularDayName: string;

  /**
   * singular_day_category is the category of the singular day (カテゴリ,
   * 年末年始/お盆/GW/その他). Populated iff singular_day_name is populated.
   * SINGULAR_DAY_CATEGORY_UNSPECIFIED otherwise.
   *
   * @generated from field: bffuser.v1.SingularDayCategory singular_day_category = 25;
   */
  singularDayCategory: SingularDayCategory;

  /**
   * actual_weather is the observed AMeDAS weather summary for target_date
   * (実績天気アイコン行). Populated when target_date is today or a past date
   * (JST) and observations are available (spec AC-DFD-002a, #6933); absent
   * otherwise.
   *
   * @generated from field: optional bffuser.v1.ForecastWeatherBar actual_weather = 26;
   */
  actualWeather?: ForecastWeatherBar;

  /**
   * case_bg_expired signals that the case's own 需要 BG is expired (失効,
   * target_date is strictly after the BG's ValidTo) on target_date —
   * distinct from not-yet-valid (適用前, target_date before ValidFrom),
   * which is out of scope and never sets this true (AC-DFC-002a,
   * demand-forecast-common.md AC-DFC-002a / 72,74,100). When true, retailers
   * is empty (no active case-BG member could be resolved) and the client
   * should show the BG-expired guidance in the table body area instead of
   * the (would-be-empty) retailer rows; header fields (bg_name / target_date,
   * carried elsewhere) remain populated as usual. Scope: Phase 1 resolves 小売
   * (LicenseType Retail) BGs only; a case whose own BG carries a non-retail
   * demand-side license (自己託送 / DR, which also uses 需要 BG codes) is out
   * of Phase 1 scope and reports false here even when expired (follow-up), so
   * consumers must not read this as "any 需要 BG expiry implies true". false
   * is also the correct value whenever retailers is non-empty.
   *
   * @generated from field: bool case_bg_expired = 27;
   */
  caseBgExpired: boolean;

  /**
   * pre_temperature_actual_slots is the observed temperature at the chart's
   * previous-day extension (23:00, 23:30).
   *
   * @generated from field: repeated bffuser.v1.SlotValue pre_temperature_actual_slots = 28;
   */
  preTemperatureActualSlots: SlotValue[];

  /**
   * pre_dewpoint_actual_slots is the observed dewpoint at the chart's
   * previous-day extension (23:00, 23:30).
   *
   * @generated from field: repeated bffuser.v1.SlotValue pre_dewpoint_actual_slots = 29;
   */
  preDewpointActualSlots: SlotValue[];

  /**
   * gate_close_frontier is the gate-close boundary at the instant this page
   * was built (the same instant gc_koma is computed from). The GC countdown
   * and the chart GC line advance it on the client
   * (frontend models/gateClose.ts) instead of re-deriving GC from the wall
   * clock.
   *
   * @generated from field: bffuser.v1.GateCloseFrontier gate_close_frontier = 30;
   */
  gateCloseFrontier?: GateCloseFrontier;

  /**
   * pre_actual_hourly_weather is the observed weather at the chart's
   * previous-day extension: the 23 時台 of the day before target_date
   * (hour = 23). Empty when that hour has no observation (spec
   * AC-DFD-006a-2: never filled from the forecast).
   *
   * @generated from field: repeated bffuser.v1.HourlyWeather pre_actual_hourly_weather = 31;
   */
  preActualHourlyWeather: HourlyWeather[];

  /**
   * post_actual_hourly_weather is the observed weather at the chart's
   * next-day extension: the 0〜2 時台 of the day after target_date
   * (hour = 0..2, the hour of that next day). Hours without an observation
   * are absent.
   *
   * @generated from field: repeated bffuser.v1.HourlyWeather post_actual_hourly_weather = 32;
   */
  postActualHourlyWeather: HourlyWeather[];

  /**
   * unattributed is the 帰属不明 breakdown of the BG total. It is kept
   * separate from retailers and always carries 48 slots.
   *
   * @generated from field: bffuser.v1.UnattributedDraft unattributed = 33;
   */
  unattributed?: UnattributedDraft;

  /**
   * bg_total_extension_forecast is the BG_TOTAL scope's chart-extension
   * demand forecast. Always set; the 帰属不明 breakdown has none because it
   * never has a confirm record.
   *
   * @generated from field: bffuser.v1.ExtensionForecastSlots bg_total_extension_forecast = 34;
   */
  bgTotalExtensionForecast?: ExtensionForecastSlots;

  /**
   * confirm_rationale is the 根拠記録 (5 free-text items) entered at business
   * confirm time (AC-DFC-005), read back on the confirmed display
   * (AC-DFC-018). Populated iff the section is confirmed (business-confirmed
   * BG_TOTAL record exists, the same record that freezes the retailer grid,
   * AC-DFC-008c); absent on the live (unconfirmed) page. A client that knows
   * the section is confirmed but receives no confirm_rationale treats it as
   * unreadable (AC-DFC-019) rather than rendering every item as 未入力.
   *
   * @generated from field: optional bffuser.v1.DemandConfirmRationale confirm_rationale = 35;
   */
  confirmRationale?: DemandConfirmRationale;
};

/**
 * Describes the message bffuser.v1.DemandForecastDailyPage.
 * Use `create(DemandForecastDailyPageSchema)` to create a new message.
 */
export const DemandForecastDailyPageSchema: GenMessage<DemandForecastDailyPage> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_demand_forecast_service, 8);

/**
 * ExtensionForecastSlots is the demand forecast drawn on the chart's
 * extensions (spec AC-DFD-006a-1), taken from the latest business-confirmed
 * record of the same scope and BG whose target_date is the day before
 * (pre_slots) or the day after (post_slots) the page's target_date, across
 * sections and excluding revoked records. A side with no such record is an
 * empty list; otherwise it has a fixed length and a koma without a value is a
 * SlotValue with value unset. Energy scale (see SlotValue doc).
 *
 * @generated from message bffuser.v1.ExtensionForecastSlots
 */
export type ExtensionForecastSlots = Message<"bffuser.v1.ExtensionForecastSlots"> & {
  /**
   * pre_slots are koma 47 and 48 (23:00, 23:30) of the previous day.
   *
   * @generated from field: repeated bffuser.v1.SlotValue pre_slots = 1;
   */
  preSlots: SlotValue[];

  /**
   * post_slots are koma 1〜6 (0:00〜2:30) of the next day.
   *
   * @generated from field: repeated bffuser.v1.SlotValue post_slots = 2;
   */
  postSlots: SlotValue[];
};

/**
 * Describes the message bffuser.v1.ExtensionForecastSlots.
 * Use `create(ExtensionForecastSlotsSchema)` to create a new message.
 */
export const ExtensionForecastSlotsSchema: GenMessage<ExtensionForecastSlots> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_demand_forecast_service, 9);

/**
 * DemandConfirmRationale is the 根拠記録 recorded at confirm time
 * (AC-DFC-005). Every item is optional; an unset item means the operator left
 * it blank (AC-DFC-018 renders it as "—").
 *
 * @generated from message bffuser.v1.DemandConfirmRationale
 */
export type DemandConfirmRationale = Message<"bffuser.v1.DemandConfirmRationale"> & {
  /**
   * curve_rationale is 需要カーブ採用根拠.
   *
   * @generated from field: optional string curve_rationale = 1;
   */
  curveRationale?: string;

  /**
   * max_power_rationale is 最大電力の根拠.
   *
   * @generated from field: optional string max_power_rationale = 2;
   */
  maxPowerRationale?: string;

  /**
   * min_power_rationale is 最小電力の根拠.
   *
   * @generated from field: optional string min_power_rationale = 3;
   */
  minPowerRationale?: string;

  /**
   * numerical_basis is 数値的根拠.
   *
   * @generated from field: optional string numerical_basis = 4;
   */
  numericalBasis?: string;

  /**
   * free_note is 自由メモ.
   *
   * @generated from field: optional string free_note = 5;
   */
  freeNote?: string;

  /**
   * unattributed_allocations are the 帰属不明の振り分け recorded with the
   * confirm, in the order they were made (AC-WFA-004 / AC-DFD-059). The screen
   * renders each as one sentence after free_note. Empty when none was made.
   *
   * @generated from field: repeated bffuser.v1.DemandUnattributedAllocation unattributed_allocations = 6;
   */
  unattributedAllocations: DemandUnattributedAllocation[];
};

/**
 * Describes the message bffuser.v1.DemandConfirmRationale.
 * Use `create(DemandConfirmRationaleSchema)` to create a new message.
 */
export const DemandConfirmRationaleSchema: GenMessage<DemandConfirmRationale> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_demand_forecast_service, 10);

/**
 * DemandUnattributedAllocation is one 帰属不明の振り分け: the 帰属不明 demand
 * added to a retailer before the confirm (AC-WFA-004 / AC-DFD-059).
 *
 * @generated from message bffuser.v1.DemandUnattributedAllocation
 */
export type DemandUnattributedAllocation = Message<"bffuser.v1.DemandUnattributedAllocation"> & {
  /**
   * retailer_business_cd is the retailer the demand was added to.
   *
   * @generated from field: string retailer_business_cd = 1;
   */
  retailerBusinessCd: string;

  /**
   * retailer_name is the retailer's name as of the allocation.
   *
   * @generated from field: string retailer_name = 2;
   */
  retailerName: string;

  /**
   * amount_kwh is the allocated demand, the sum of the 48 komas' 帰属不明
   * (送電端 kWh).
   *
   * @generated from field: google.type.Decimal amount_kwh = 3;
   */
  amountKwh?: Decimal;

  /**
   * allocated_by is the actor ID that allocated it (the automation's is
   * system-automatic-execution).
   *
   * @generated from field: string allocated_by = 4;
   */
  allocatedBy: string;

  /**
   * allocated_at is when it was allocated.
   *
   * @generated from field: google.protobuf.Timestamp allocated_at = 5;
   */
  allocatedAt?: Timestamp;
};

/**
 * Describes the message bffuser.v1.DemandUnattributedAllocation.
 * Use `create(DemandUnattributedAllocationSchema)` to create a new message.
 */
export const DemandUnattributedAllocationSchema: GenMessage<DemandUnattributedAllocation> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_demand_forecast_service, 11);

/**
 * UnattributedDraft is the 帰属不明 breakdown. It has the same draft values as
 * RetailerDraft but no retailer identifier.
 *
 * @generated from message bffuser.v1.UnattributedDraft
 */
export type UnattributedDraft = Message<"bffuser.v1.UnattributedDraft"> & {
  /**
   * @generated from field: repeated bffuser.v1.SlotValue forecast_slots = 1;
   */
  forecastSlots: SlotValue[];

  /**
   * @generated from field: repeated bffuser.v1.SlotValue provider_slots = 2;
   */
  providerSlots: SlotValue[];

  /**
   * @generated from field: repeated int32 manual_edit_komas = 3;
   */
  manualEditKomas: number[];

  /**
   * @generated from field: bffuser.v1.DemandForecastProvider provider = 4;
   */
  provider: DemandForecastProvider;

  /**
   * @generated from field: optional string provider_other = 5;
   */
  providerOther?: string;

  /**
   * @generated from field: optional string provider_label = 6;
   */
  providerLabel?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp draft_updated_at = 7;
   */
  draftUpdatedAt?: Timestamp;
};

/**
 * Describes the message bffuser.v1.UnattributedDraft.
 * Use `create(UnattributedDraftSchema)` to create a new message.
 */
export const UnattributedDraftSchema: GenMessage<UnattributedDraft> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_demand_forecast_service, 12);

/**
 * RetailerDraft carries the draft state for a single retailer within the
 * aggregated page. retailer_business_cd is also used as scope_identifier in
 * Save / Confirm requests.
 *
 * @generated from message bffuser.v1.RetailerDraft
 */
export type RetailerDraft = Message<"bffuser.v1.RetailerDraft"> & {
  /**
   * retailer_business_cd is the retailer's 4-char OCCTO business code
   * (= scope_identifier for Save / Confirm).
   *
   * @generated from field: string retailer_business_cd = 1;
   */
  retailerBusinessCd: string;

  /**
   * display_name is the human-readable name of the retailer BG.
   *
   * @generated from field: string display_name = 2;
   */
  displayName: string;

  /**
   * forecast_slots contains the current demand forecast values after any
   * manual edits. Always 48 elements (scale: see SlotValue doc). Empty slot
   * = value absent.
   *
   * @generated from field: repeated bffuser.v1.SlotValue forecast_slots = 3;
   */
  forecastSlots: SlotValue[];

  /**
   * provider_slots contains the provider-sourced values before manual edits.
   * Always 48 elements. Empty when no provider source has been applied.
   *
   * @generated from field: repeated bffuser.v1.SlotValue provider_slots = 4;
   */
  providerSlots: SlotValue[];

  /**
   * manual_edit_komas lists the 1-indexed koma numbers that have been
   * manually edited relative to the provider source.
   *
   * @generated from field: repeated int32 manual_edit_komas = 5;
   */
  manualEditKomas: number[];

  /**
   * provider is the data source classification for this draft.
   *
   * @generated from field: bffuser.v1.DemandForecastProvider provider = 6;
   */
  provider: DemandForecastProvider;

  /**
   * provider_other is a free-text description used when
   * provider = DEMAND_FORECAST_PROVIDER_OTHER.
   *
   * @generated from field: optional string provider_other = 7;
   */
  providerOther?: string;

  /**
   * provider_label is a frozen display name snapshot of the provider.
   *
   * @generated from field: optional string provider_label = 8;
   */
  providerLabel?: string;

  /**
   * draft_updated_at is the updated_at timestamp of the current draft,
   * used as the per-retailer optimistic-lock baseline for Save and Confirm
   * requests (= RetailerConfirmTarget.expected_updated_at). Absent when no
   * draft has been saved yet for this retailer. Clients must hold this value
   * as a proto Timestamp (not converted to Date) to preserve microsecond
   * precision.
   *
   * @generated from field: optional google.protobuf.Timestamp draft_updated_at = 9;
   */
  draftUpdatedAt?: Timestamp;

  /**
   * extension_forecast is this retailer's chart-extension demand forecast
   * (RETAIL scope with this retailer_business_cd). Always set.
   *
   * @generated from field: bffuser.v1.ExtensionForecastSlots extension_forecast = 10;
   */
  extensionForecast?: ExtensionForecastSlots;
};

/**
 * Describes the message bffuser.v1.RetailerDraft.
 * Use `create(RetailerDraftSchema)` to create a new message.
 */
export const RetailerDraftSchema: GenMessage<RetailerDraft> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_demand_forecast_service, 13);

/**
 * SlotValue represents a single 30-minute slot value in a 48-slot series.
 * The field is optional to distinguish an empty cell (未入力) from an explicit
 * zero. Scale depends on what the field represents:
 *  - Energy-quantity fields (forecast_slots / provider_slots /
 *    today_actual_slots / prev_day_actual_slots / bg_total_slots /
 *    corrected_slots / ConfirmRecordRetailPreviewResult.forecast_slots, and
 *    other SlotValue-typed fields carrying demand values across this file) are all
 *    送電端 kWh/30min (backend domain SoT:
 *    go/internal/backend/domain/entity/demand/forecast_draft.go, DB SoT:
 *    go/internal/backend/infrastructure/persistence/model/demand.go). This
 *    doc is the single source of truth for that scale — individual
 *    energy-field comments elsewhere should not restate it.
 *  - temperature_forecast_slots / temperature_actual_slots /
 *    dewpoint_actual_slots (and PastActual.temperature_slots /
 *    PastActual.dewpoint_slots) are ℃ and are NOT covered by the scale
 *    above.
 * The index within a repeated field corresponds to koma number - 1 (i.e.
 * index 0 = koma 1, index 47 = koma 48).
 *
 * @generated from message bffuser.v1.SlotValue
 */
export type SlotValue = Message<"bffuser.v1.SlotValue"> & {
  /**
   * value holds the quantity described by the containing field (scale: see
   * message doc above — 送電端 kWh/30min for energy fields, ℃ for
   * temperature/dewpoint fields). When absent the slot is considered empty
   * (空セル). An explicit 0 means an explicit zero value (zero demand, or
   * 0℃), not a missing measurement.
   *
   * @generated from field: optional google.type.Decimal value = 1;
   */
  value?: Decimal;
};

/**
 * Describes the message bffuser.v1.SlotValue.
 * Use `create(SlotValueSchema)` to create a new message.
 */
export const SlotValueSchema: GenMessage<SlotValue> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_demand_forecast_service, 14);

/**
 * PastActual is one day of historical actual demand values for comparison.
 *
 * @generated from message bffuser.v1.PastActual
 */
export type PastActual = Message<"bffuser.v1.PastActual"> & {
  /**
   * date is the calendar date of the historical actual.
   *
   * @generated from field: google.type.Date date = 1;
   */
  date?: Date;

  /**
   * slots contains the 48-slot actual values for this date (エリア合計,
   * owner_business_code="-ALL"). Unchanged by the per-retailer fields below —
   * consumers that only need the area total keep reading this field.
   *
   * @generated from field: repeated bffuser.v1.SlotValue slots = 2;
   */
  slots: SlotValue[];

  /**
   * temperature_slots contains the observed temperature (実績気温) for this
   * past date, used to plot the selected past day's temperature on the
   * chart's secondary axis (spec AC-024, design doc AC-23). max_items = 48
   * (single past-day scope, distinct from the 54-item cap of
   * temperature_forecast_slots, which carries the target day's 24 時の点).
   *
   * @generated from field: repeated bffuser.v1.SlotValue temperature_slots = 3;
   */
  temperatureSlots: SlotValue[];

  /**
   * dewpoint_slots is the per-koma observed dewpoint series of the past day
   * (AC-024), used to plot the selected past day's dewpoint on the chart's
   * secondary axis alongside temperature_slots. max_items = 48 (same scope as
   * temperature_slots above). Empty slot = observation missing for that koma.
   *
   * @generated from field: repeated bffuser.v1.SlotValue dewpoint_slots = 4;
   */
  dewpointSlots: SlotValue[];

  /**
   * retailer_slots carries this date's 48-slot actual value resolved
   * per-retailer (帰属事業者コードで解決した実績値, spec AC-DFD-047/047a), one
   * entry per retailer under the case's BG. A retailer with no attributed row
   * for this date still gets an entry, whose slots are 48 value-less elements
   * (= no actual, not "not requested"; NOT a 0-length list) — 需要想定 Design
   * Note demand-forecast-adopt-actual-per-retailer.md Decision 5. Mirrors
   * internalapi.v1.PastActualRetailerSlots.
   *
   * @generated from field: repeated bffuser.v1.PastActualRetailerSlots retailer_slots = 5;
   */
  retailerSlots: PastActualRetailerSlots[];

  /**
   * owner_breakdown_available is false when this date's actual arrived before
   * 事業者単位の帰属解決と集計 (owner axis, PR #6010) was enabled for it — the
   * -ALL row exists but no per-owner row does, so retailer_slots carries no
   * usable per-retailer split for this date (Decision 3). Absent actuals
   * (no -ALL row either) are vacuously true. Wire default false is
   * intentional fail-closed for a rolling deploy against an old backend
   * (Decision 5).
   *
   * @generated from field: bool owner_breakdown_available = 6;
   */
  ownerBreakdownAvailable: boolean;

  /**
   * unknown_owner is set only when this date's actual included supply points
   * that could not be attributed to a retailer (帰属不明, AC-DFD-047c). Absent
   * means no unattributed points existed for this date (do not notify).
   *
   * @generated from field: optional bffuser.v1.PastActualUnknownOwner unknown_owner = 7 [deprecated = true];
   * @deprecated
   */
  unknownOwner?: PastActualUnknownOwner;

  /**
   * unattributed_slots carries the actuals whose retailer could not be
   * resolved. The frontend adopts this as the unattributed breakdown.
   *
   * @generated from field: repeated bffuser.v1.SlotValue unattributed_slots = 8;
   */
  unattributedSlots: SlotValue[];
};

/**
 * Describes the message bffuser.v1.PastActual.
 * Use `create(PastActualSchema)` to create a new message.
 */
export const PastActualSchema: GenMessage<PastActual> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_demand_forecast_service, 15);

/**
 * PastActualRetailerSlots is one retailer's 48-slot actual demand series for
 * a PastActual date. Mirrors internalapi.v1.PastActualRetailerSlots; kept
 * BFF-local to allow independent evolution from the backend message.
 *
 * @generated from message bffuser.v1.PastActualRetailerSlots
 */
export type PastActualRetailerSlots = Message<"bffuser.v1.PastActualRetailerSlots"> & {
  /**
   * retailer_business_cd is the retailer's 4-char OCCTO business code (same
   * identifier as RetailerDraft.retailer_business_cd).
   *
   * @generated from field: string retailer_business_cd = 1;
   */
  retailerBusinessCd: string;

  /**
   * slots contains the 48-slot actual values attributed to this retailer.
   * Always 48 elements with each SlotValue.value unset (not a 0-length
   * list) when this retailer has no attributed row for the date (= no
   * actual for this retailer, distinct from an unrequested retailer) —
   * do not use slots.length to detect "no actual"; check each SlotValue's
   * value presence instead (same convention as every other SlotValue-typed
   * field in this file).
   *
   * @generated from field: repeated bffuser.v1.SlotValue slots = 2;
   */
  slots: SlotValue[];
};

/**
 * Describes the message bffuser.v1.PastActualRetailerSlots.
 * Use `create(PastActualRetailerSlotsSchema)` to create a new message.
 */
export const PastActualRetailerSlotsSchema: GenMessage<PastActualRetailerSlots> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_demand_forecast_service, 16);

/**
 * PastActualUnknownOwner carries the day-level attribution-failure count for
 * a PastActual date (帰属不明分, AC-DFD-047c). Mirrors
 * internalapi.v1.PastActualUnknownOwner.
 *
 * @generated from message bffuser.v1.PastActualUnknownOwner
 */
export type PastActualUnknownOwner = Message<"bffuser.v1.PastActualUnknownOwner"> & {
  /**
   * supply_point_count is the LARGEST per-koma count of supply points that
   * could not be attributed to a retailer, taken across this date's komas
   * (per-koma COUNT(*) folded by MAX). It APPROXIMATES the day's distinct
   * count and can under-report it when the unattributed set varies between
   * komas — do not present it as an exact distinct count. Absent means the
   * count was not recorded (集計が demand_actual_koma.supply_point_count 列の
   * 追加前に完了した日, forward-only rollout — Decision 1/8): unattributed
   * points existed (this message is present) but their count is unknown.
   *
   * @generated from field: optional int32 supply_point_count = 1;
   */
  supplyPointCount?: number;
};

/**
 * Describes the message bffuser.v1.PastActualUnknownOwner.
 * Use `create(PastActualUnknownOwnerSchema)` to create a new message.
 */
export const PastActualUnknownOwnerSchema: GenMessage<PastActualUnknownOwner> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_demand_forecast_service, 17);

/**
 * ForecastWeatherBar carries the weather forecast data for the target date
 * (気象予報サマリ, AC-DFC-008). Mirrors internalapi.v1.ForecastWeatherBar;
 * kept BFF-local to allow independent evolution from the backend message.
 *
 * @generated from message bffuser.v1.ForecastWeatherBar
 */
export type ForecastWeatherBar = Message<"bffuser.v1.ForecastWeatherBar"> & {
  /**
   * data_source is the display name of the weather data provider.
   * Phase 1: always "JMA 公開予報". Phase 2+: contracted provider name.
   *
   * @generated from field: string data_source = 1;
   */
  dataSource: string;

  /**
   * observation_point_name is the weather observation point name linked to
   * the selected area.
   *
   * @generated from field: string observation_point_name = 2;
   */
  observationPointName: string;

  /**
   * received_at is the timestamp at which the weather forecast was received
   * (受信・取込時刻), passed straight through from the internal API for wire
   * parity with internalapi.v1.ForecastWeatherBar. The frontend does not
   * consume it: freshness monitoring / failure investigation (AC-WD-005b) is
   * a backend-side concern, not something this frontend contract performs.
   * It is NOT displayed in the weather bar — forecasted_at is used instead
   * (AC-DFC-008d).
   *
   * @generated from field: optional google.protobuf.Timestamp received_at = 3;
   */
  receivedAt?: Timestamp;

  /**
   * max_temperature is the forecasted maximum temperature (celsius).
   *
   * @generated from field: optional google.type.Decimal max_temperature = 4;
   */
  maxTemperature?: Decimal;

  /**
   * min_temperature is the forecasted minimum temperature (celsius).
   *
   * @generated from field: optional google.type.Decimal min_temperature = 5;
   */
  minTemperature?: Decimal;

  /**
   * hourly_weather lists the per-time-block weather conditions (時間帯別天気).
   * Ordered chronologically. For a VPFD source, up to 8 entries (3-hour
   * blocks); a block with no on-the-hour forecast point has no entry
   * (AC-WD-003a). For PREFECTURAL / WEEKLY, exactly 1 entry (hour 0): the
   * daily reading, not replicated per block (AC-WD-007a).
   *
   * @generated from field: repeated bffuser.v1.HourlyWeather hourly_weather = 6;
   */
  hourlyWeather: HourlyWeather[];

  /**
   * forecasted_at is the timestamp at which the forecast source (P0: JMA
   * public forecast) issued this forecast (発表時刻). This is the timestamp
   * the weather bar displays (AC-DFC-008d) — distinct from received_at (when
   * the system ingested it).
   *
   * @generated from field: optional google.protobuf.Timestamp forecasted_at = 7;
   */
  forecastedAt?: Timestamp;

  /**
   * weather_source identifies which JMA forecast source the target date's
   * weather (hourly_weather) was resolved from (AC-WD-009 / AC-WD-010). When
   * it is WEATHER_SOURCE_PREFECTURAL or WEATHER_SOURCE_WEEKLY, hourly_weather
   * is a single daily reading (one hourly_weather entry, not a 3-hour
   * series), so the frontend must render a single daily icon instead of the
   * per-block row (AC-WD-007a: 翌日断面で当日 05 時の時系列予報発表前).
   * WEATHER_SOURCE_VPFD means real 3-hour blocks. For a confirmed snapshot it
   * is the source recorded at confirm time; UNSPECIFIED means the source is
   * not known (a snapshot recorded before it was kept): treat as not daily.
   * Always UNSPECIFIED on the actual_weather bar (観測実績に予報の取得元は無い).
   *
   * @generated from field: bffuser.v1.WeatherSource weather_source = 8;
   */
  weatherSource: WeatherSource;
};

/**
 * Describes the message bffuser.v1.ForecastWeatherBar.
 * Use `create(ForecastWeatherBarSchema)` to create a new message.
 */
export const ForecastWeatherBarSchema: GenMessage<ForecastWeatherBar> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_demand_forecast_service, 18);

/**
 * HourlyWeather is a single time-block weather entry in the summary. Mirrors
 * internalapi.v1.HourlyWeather; kept BFF-local.
 *
 * @generated from message bffuser.v1.HourlyWeather
 */
export type HourlyWeather = Message<"bffuser.v1.HourlyWeather"> & {
  /**
   * hour is the start hour of this block (0-23, JST).
   *
   * @generated from field: int32 hour = 1;
   */
  hour: number;

  /**
   * weather_code is the JMA weather code (晴れ=100, 曇り=200, 雨=300, etc.).
   * Frontend maps this to an icon. Not enum-typed: the JMA code system has
   * 30+ values, which would be excessive to enumerate in proto.
   *
   * @generated from field: int32 weather_code = 2;
   */
  weatherCode: number;

  /**
   * temperature is the forecasted temperature for this block (celsius).
   *
   * @generated from field: optional google.type.Decimal temperature = 3;
   */
  temperature?: Decimal;
};

/**
 * Describes the message bffuser.v1.HourlyWeather.
 * Use `create(HourlyWeatherSchema)` to create a new message.
 */
export const HourlyWeatherSchema: GenMessage<HourlyWeather> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_demand_forecast_service, 19);

/**
 * LossRateBreakdown carries the loss rate percentages by voltage class for
 * the selected area (損失率内訳, AC-DFC-010). Mirrors
 * internalapi.v1.LossRateBreakdown; kept BFF-local.
 *
 * @generated from message bffuser.v1.LossRateBreakdown
 */
export type LossRateBreakdown = Message<"bffuser.v1.LossRateBreakdown"> & {
  /**
   * extra_high_voltage_rate is the loss rate for extra-high voltage
   * (特別高圧, %).
   *
   * @generated from field: google.type.Decimal extra_high_voltage_rate = 1;
   */
  extraHighVoltageRate?: Decimal;

  /**
   * high_voltage_rate is the loss rate for high voltage (高圧, %).
   *
   * @generated from field: google.type.Decimal high_voltage_rate = 2;
   */
  highVoltageRate?: Decimal;

  /**
   * low_voltage_rate is the loss rate for low voltage (低圧, %).
   *
   * @generated from field: google.type.Decimal low_voltage_rate = 3;
   */
  lowVoltageRate?: Decimal;

  /**
   * effective_date is the date from which this loss rate setting is
   * effective.
   *
   * @generated from field: google.type.Date effective_date = 4;
   */
  effectiveDate?: Date;
};

/**
 * Describes the message bffuser.v1.LossRateBreakdown.
 * Use `create(LossRateBreakdownSchema)` to create a new message.
 */
export const LossRateBreakdownSchema: GenMessage<LossRateBreakdown> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_demand_forecast_service, 20);

/**
 * SimilarDayCandidate is a single candidate day returned by SearchSimilarDays.
 * Similarity is measured by S(d) (lower = more similar).
 *
 * @generated from message bffuser.v1.SimilarDayCandidate
 */
export type SimilarDayCandidate = Message<"bffuser.v1.SimilarDayCandidate"> & {
  /**
   * date is the calendar date of the candidate day.
   *
   * @generated from field: google.type.Date date = 1;
   */
  date?: Date;

  /**
   * weekday_category classifies the candidate day as weekday / Saturday /
   * holiday (平日 / 土曜 / 日祝).
   *
   * @generated from field: bffuser.v1.WeekdayCategory weekday_category = 2;
   */
  weekdayCategory: WeekdayCategory;

  /**
   * holiday_name is the Japanese public holiday name when the candidate day
   * is a public holiday. Empty string for non-holidays.
   *
   * @generated from field: string holiday_name = 3;
   */
  holidayName: string;

  /**
   * weather_category: 過去日の日次代表天気。旧 weather_code (int32) の in-place
   * 置換 (field 番号 4 維持 = varint wire 互換、同時デプロイのため v2 分離しない —
   * buf.yaml breaking(FILE) からの意図的逸脱。
   * 理由: docs/adr/demand-forecast-similar-day-weather-category.md 参照)。
   *
   * @generated from field: bffuser.v1.WeatherCategory weather_category = 4;
   */
  weatherCategory: WeatherCategory;

  /**
   * max_temp is the observed maximum temperature for the candidate day.
   * Absent when observation data is not available.
   *
   * @generated from field: optional google.type.Decimal max_temp = 5;
   */
  maxTemp?: Decimal;

  /**
   * min_temp is the observed minimum temperature for the candidate day.
   * Absent when observation data is not available.
   *
   * @generated from field: optional google.type.Decimal min_temp = 6;
   */
  minTemp?: Decimal;

  /**
   * demand_max_mw is the peak demand in MW (送電端換算) for the candidate
   * day. Absent when demand data is not available.
   *
   * @generated from field: optional google.type.Decimal demand_max_mw = 7;
   */
  demandMaxMw?: Decimal;

  /**
   * demand_min_mw is the trough demand in MW for the candidate day.
   * Absent when demand data is not available.
   *
   * @generated from field: optional google.type.Decimal demand_min_mw = 8;
   */
  demandMinMw?: Decimal;

  /**
   * similarity_score is the similarity index S(d) for the candidate day.
   * Lower values indicate greater similarity to the target date. Present only
   * for candidates within the auto-selection pool; absent for a display-only
   * day outside the pool (AC-DFD-014/025, mirrors internalapi's
   * SimilarDayCandidate.similarity_score presence semantics).
   *
   * @generated from field: optional google.type.Decimal similarity_score = 9;
   */
  similarityScore?: Decimal;

  /**
   * auto_selected indicates whether this candidate was automatically selected
   * by the backend (true when within the top auto_select_count candidates).
   *
   * @generated from field: bool auto_selected = 10;
   */
  autoSelected: boolean;

  /**
   * day_type is the 4-category classification of the candidate day
   * (spec §8, AC-DFD-014: 平日 / 土曜 / 休日（日祝）/ 特異日). Always
   * populated by the backend (AC-04): a registered singular day is
   * DAY_TYPE_SINGULAR regardless of its demand behavior, then holiday-first
   * for the remaining three categories. UNSPECIFIED is not returned.
   *
   * @generated from field: bffuser.v1.DayType day_type = 11;
   */
  dayType: DayType;

  /**
   * dewpoint_celsius is the candidate day's observed dewpoint (露点), the
   * per-koma dewpoint series' daily mean rounded to 0.1℃ (spec §機能詳細
   * 「露点 ℃」). Absent when a single day's observation is missing (AC-DFD-017a
   * graceful degrade, same absence semantics as max_temp/min_temp).
   *
   * @generated from field: optional google.type.Decimal dewpoint_celsius = 12;
   */
  dewpointCelsius?: Decimal;
};

/**
 * Describes the message bffuser.v1.SimilarDayCandidate.
 * Use `create(SimilarDayCandidateSchema)` to create a new message.
 */
export const SimilarDayCandidateSchema: GenMessage<SimilarDayCandidate> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_demand_forecast_service, 21);

/**
 * TrendReflectionPreview is the preview of slot values after applying the
 * trend correction computed from the target day's own actual/plan deviation
 * (当日実績/想定の至近乖離率). Only applicable to the same-day section
 * (WORKFLOW_SECTION_TODAY). Mirrors internalapi.v1.TrendReflectionPreview;
 * kept BFF-local.
 *
 * @generated from message bffuser.v1.TrendReflectionPreview
 */
export type TrendReflectionPreview = Message<"bffuser.v1.TrendReflectionPreview"> & {
  /**
   * avg_ratio is the average demand ratio over the recent komas (当日実績/想定
   * の至近乖離率), used as the correction multiplier (V_plan × avg_ratio).
   * 乗率 (ratio, 1.0 = 想定と実績が一致) であり、百分率の乖離率
   * (deviation %) ではない — frontend の乖離率バッジは (avg_ratio - 1) × 100
   * で百分率化して表示する (DeviationBadge.tsx)。
   *
   * @generated from field: google.type.Decimal avg_ratio = 1;
   */
  avgRatio?: Decimal;

  /**
   * corrected_slots is the BG-total corrected forecast slot series: for each
   * koma, Σ_retailer retailer_corrected_slots[*].corrected_slots[koma] (the
   * per-retailer values are NOT rounded — 需要想定値は小数のまま保持する,
   * AC-DFC-EDIT-003 / AC-DFD-012 — so the BG total equals Σ_retailer plan ×
   * avg_ratio exactly and matches what Apply persists). komas after the gate-closed koma (GC以降) carry
   * the correction; komas before or at GC carry the original (= Σ_retailer
   * plan) values unchanged. Always 48 elements.
   *
   * @generated from field: repeated bffuser.v1.SlotValue corrected_slots = 2;
   */
  correctedSlots: SlotValue[];

  /**
   * applicable_koma_count is the number of komas to which the correction is
   * applied (= komas after the gate-closed koma).
   *
   * @generated from field: int32 applicable_koma_count = 3;
   */
  applicableKomaCount: number;

  /**
   * retailer_corrected_slots carries the same GC以降補正 broken out per
   * retailer (demand-trend-reflection-single-authority design D1/D3):
   * frontend adopts these series verbatim into each retailer's editRow (no
   * client-side multiply/round/GC-gate logic). One entry per case-BG
   * retailer; order is not guaranteed — callers must join by
   * retailer_business_cd.
   *
   * @generated from field: repeated bffuser.v1.RetailerCorrectedSlots retailer_corrected_slots = 4;
   */
  retailerCorrectedSlots: RetailerCorrectedSlots[];
};

/**
 * Describes the message bffuser.v1.TrendReflectionPreview.
 * Use `create(TrendReflectionPreviewSchema)` to create a new message.
 */
export const TrendReflectionPreviewSchema: GenMessage<TrendReflectionPreview> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_demand_forecast_service, 22);

/**
 * RetailerCorrectedSlots is one retailer's GC以降-corrected 48-koma series
 * (TrendReflectionPreview.retailer_corrected_slots). Mirrors
 * internalapi.v1.RetailerCorrectedSlots; kept BFF-local.
 *
 * @generated from message bffuser.v1.RetailerCorrectedSlots
 */
export type RetailerCorrectedSlots = Message<"bffuser.v1.RetailerCorrectedSlots"> & {
  /**
   * retailer_business_cd is the retailer's 4-char OCCTO business code, the
   * same identity used as the demand forecast draft's RETAIL-scope
   * scope_identifier.
   *
   * @generated from field: string retailer_business_cd = 1;
   */
  retailerBusinessCd: string;

  /**
   * corrected_slots is this retailer's corrected forecast slot series: komas
   * after the gate-closed koma (GC以降) are V_plan × avg_ratio (丸めない,
   * AC-DFC-EDIT-003; TrendReflectionPreview.avg_ratio); komas before or at GC carry the
   * retailer's original plan value unchanged. Always 48 elements.
   *
   * @generated from field: repeated bffuser.v1.SlotValue corrected_slots = 2;
   */
  correctedSlots: SlotValue[];
};

/**
 * Describes the message bffuser.v1.RetailerCorrectedSlots.
 * Use `create(RetailerCorrectedSlotsSchema)` to create a new message.
 */
export const RetailerCorrectedSlotsSchema: GenMessage<RetailerCorrectedSlots> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_demand_forecast_service, 23);

/**
 * SearchSimilarDaysRequest carries the search parameters for similar-day
 * retrieval.
 *
 * @generated from message bffuser.v1.SearchSimilarDaysRequest
 */
export type SearchSimilarDaysRequest = Message<"bffuser.v1.SearchSimilarDaysRequest"> & {
  /**
   * case_id is the WorkflowCase identifier (UUID). Used by the BFF handler
   * to resolve the area_code and organization context; not forwarded to
   * internalapi.
   *
   * @generated from field: string case_id = 1;
   */
  caseId: string;

  /**
   * area_code identifies the electricity supply region. Must not be
   * UNSPECIFIED.
   *
   * @generated from field: bfftypes.v1.AreaCode area_code = 2;
   */
  areaCode: AreaCode;

  /**
   * target_date is the forecast date for which similar days are searched.
   * Required.
   *
   * @generated from field: google.type.Date target_date = 3;
   */
  targetDate?: Date;

  /**
   * lookback_days is the number of past days to search within. Must be
   * between 7 and 365 inclusive when set (AC-018: gte=7). When zero
   * (= proto3 default), the backend uses the Config default (30 days).
   *
   * @generated from field: int32 lookback_days = 4;
   */
  lookbackDays: number;

  /**
   * auto_select_count is the number of top-ranked similar days to
   * auto-select (0 = no auto-selection, default 3, max 5; spec AC-019, design
   * doc AC-21: host-screen configurable up to 5, relaxed from the prior
   * max 3).
   *
   * @generated from field: int32 auto_select_count = 5;
   */
  autoSelectCount: number;
};

/**
 * Describes the message bffuser.v1.SearchSimilarDaysRequest.
 * Use `create(SearchSimilarDaysRequestSchema)` to create a new message.
 */
export const SearchSimilarDaysRequestSchema: GenMessage<SearchSimilarDaysRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_demand_forecast_service, 24);

/**
 * SearchSimilarDaysResponse carries the ranked list of similar-day candidates.
 *
 * @generated from message bffuser.v1.SearchSimilarDaysResponse
 */
export type SearchSimilarDaysResponse = Message<"bffuser.v1.SearchSimilarDaysResponse"> & {
  /**
   * candidates is the similar-day candidate list, ordered by date descending
   * (newest past date first) for operator display. similarity-score ranking is
   * preserved separately: `SimilarDayCandidate.auto_selected` flags the top-N
   * by S(d), and the persisted SimilarDaySearchExecution's `Rank` field is
   * the audit record of the full similarity order.
   *
   * @generated from field: repeated bffuser.v1.SimilarDayCandidate candidates = 1;
   */
  candidates: SimilarDayCandidate[];

  /**
   * execution_id is the UUID of the SimilarDaySearchExecution record
   * persisted for this search. Pass back via RecordSimilarDayPicks.
   *
   * @generated from field: string execution_id = 2;
   */
  executionId: string;
};

/**
 * Describes the message bffuser.v1.SearchSimilarDaysResponse.
 * Use `create(SearchSimilarDaysResponseSchema)` to create a new message.
 */
export const SearchSimilarDaysResponseSchema: GenMessage<SearchSimilarDaysResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_demand_forecast_service, 25);

/**
 * RecordSimilarDayPicksRequest records the operator's selected ("applied")
 * similar-day candidates. organization_id is intentionally absent; resolved
 * from eauth.
 *
 * @generated from message bffuser.v1.RecordSimilarDayPicksRequest
 */
export type RecordSimilarDayPicksRequest = Message<"bffuser.v1.RecordSimilarDayPicksRequest"> & {
  /**
   * case_id is the WorkflowCase identifier (UUID).
   *
   * @generated from field: string case_id = 1;
   */
  caseId: string;

  /**
   * execution_id is the UUID of the SimilarDaySearchExecution.
   *
   * @generated from field: string execution_id = 2;
   */
  executionId: string;

  /**
   * picked_dates are the similar-day dates the operator selected. At least
   * 1 and at most 5 dates (AC-DFD-021: 類似日検索ダイアログの選択上限 5 件).
   *
   * @generated from field: repeated google.type.Date picked_dates = 3;
   */
  pickedDates: Date[];
};

/**
 * Describes the message bffuser.v1.RecordSimilarDayPicksRequest.
 * Use `create(RecordSimilarDayPicksRequestSchema)` to create a new message.
 */
export const RecordSimilarDayPicksRequestSchema: GenMessage<RecordSimilarDayPicksRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_demand_forecast_service, 26);

/**
 * RecordSimilarDayPicksResponse is intentionally empty.
 *
 * @generated from message bffuser.v1.RecordSimilarDayPicksResponse
 */
export type RecordSimilarDayPicksResponse = Message<"bffuser.v1.RecordSimilarDayPicksResponse"> & {
};

/**
 * Describes the message bffuser.v1.RecordSimilarDayPicksResponse.
 * Use `create(RecordSimilarDayPicksResponseSchema)` to create a new message.
 */
export const RecordSimilarDayPicksResponseSchema: GenMessage<RecordSimilarDayPicksResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_demand_forecast_service, 27);

/**
 * PreviewConfirmRecordRequest instructs the backend to preview a previously
 * confirmed demand record (DemandConfirmRecord) as a non-destructive
 * reference column (確定履歴の参照列プレビュー, s07-confirm-history-import-
 * reference-view.md). organization_id is intentionally absent; resolved from
 * eauth. Supports both RETAIL (single retailer) and BG_TOTAL (per-retailer
 * direct preview from confirm batch, ADR
 * demand-forecast-bg-import-per-retailer-direct). No optimistic-lock baseline
 * is needed for either scope: preview never reads or writes the draft.
 *
 * @generated from message bffuser.v1.PreviewConfirmRecordRequest
 */
export type PreviewConfirmRecordRequest = Message<"bffuser.v1.PreviewConfirmRecordRequest"> & {
  /**
   * case_id is the WorkflowCase identifier (UUID).
   *
   * @generated from field: string case_id = 1;
   */
  caseId: string;

  /**
   * area_code identifies the electricity supply region. Must not be UNSPECIFIED.
   *
   * @generated from field: bfftypes.v1.AreaCode area_code = 2;
   */
  areaCode: AreaCode;

  /**
   * target_date is the forecast date. Required.
   *
   * @generated from field: google.type.Date target_date = 3;
   */
  targetDate?: Date;

  /**
   * section is the planning horizon (断面). Must not be UNSPECIFIED.
   *
   * @generated from field: bffuser.v1.WorkflowSection section = 4;
   */
  section: WorkflowSection;

  /**
   * scope is the demand aggregation unit. RETAIL or BG_TOTAL.
   *
   * @generated from field: bffuser.v1.AggregationScope scope = 5;
   */
  scope: AggregationScope;

  /**
   * retailer_business_cd is the retailer's 4-char OCCTO business code for
   * RETAIL scope (兄弟 PreviewSimpleForecast と対称). Optional: omit for
   * BG_TOTAL scope where scope_identifier is not meaningful (AC-DFD-032).
   *
   * @generated from field: optional string retailer_business_cd = 6;
   */
  retailerBusinessCd?: string;

  /**
   * confirm_record_id is the UUID of the DemandConfirmRecord to preview.
   *
   * @generated from field: string confirm_record_id = 7;
   */
  confirmRecordId: string;

  /**
   * bg_retailer_business_cds carries the retailer_business_cd list currently
   * under the BG at call time (AC-DFD-032 内訳差分ハンドリング), used for
   * BG_TOTAL scope. Not an optimistic-lock baseline (preview never writes).
   * protovalidate: (scope==RETAIL) → retailer_business_cd 必須 &&
   * bg_retailer_business_cds 空 / (scope==BG_TOTAL) → retailer_business_cd 空
   * && bg_retailer_business_cds 非空 — validated in the usecase layer (not
   * CEL), mirrors the mutual-exclusion shape
   * of the former ImportConfirmRecordToDraftRequest's scope <-> bg_targets
   * check.
   *
   * @generated from field: repeated string bg_retailer_business_cds = 8;
   */
  bgRetailerBusinessCds: string[];
};

/**
 * Describes the message bffuser.v1.PreviewConfirmRecordRequest.
 * Use `create(PreviewConfirmRecordRequestSchema)` to create a new message.
 */
export const PreviewConfirmRecordRequestSchema: GenMessage<PreviewConfirmRecordRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_demand_forecast_service, 28);

/**
 * RetailerPreviewEntry carries the previewed confirm-record values for a
 * single retailer within a BG-total PreviewConfirmRecord operation.
 *
 * @generated from message bffuser.v1.RetailerPreviewEntry
 */
export type RetailerPreviewEntry = Message<"bffuser.v1.RetailerPreviewEntry"> & {
  /**
   * retailer_business_cd identifies the retailer (4-char OCCTO business code).
   *
   * @generated from field: string retailer_business_cd = 1;
   */
  retailerBusinessCd: string;

  /**
   * forecast_slots contains the confirm record's own demand forecast values
   * for this retailer (no scope_scale apportionment, ADR
   * demand-forecast-bg-import-per-retailer-direct). Always 48 elements.
   *
   * @generated from field: repeated bffuser.v1.SlotValue forecast_slots = 2;
   */
  forecastSlots: SlotValue[];
};

/**
 * Describes the message bffuser.v1.RetailerPreviewEntry.
 * Use `create(RetailerPreviewEntrySchema)` to create a new message.
 */
export const RetailerPreviewEntrySchema: GenMessage<RetailerPreviewEntry> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_demand_forecast_service, 29);

/**
 * ConfirmRecordRetailPreviewResult carries the previewed confirm-record
 * values for a single-retailer (RETAIL scope) PreviewConfirmRecord operation.
 * Named distinctly from the sibling PreviewSimpleForecast's RetailPreviewResult
 * (same file, different shape) to avoid a message-name collision.
 *
 * @generated from message bffuser.v1.ConfirmRecordRetailPreviewResult
 */
export type ConfirmRecordRetailPreviewResult = Message<"bffuser.v1.ConfirmRecordRetailPreviewResult"> & {
  /**
   * forecast_slots contains the confirm record's own demand forecast values
   * (送電端 kWh/30min; scale: see SlotValue doc), verbatim (no GC 温存 merge —
   * 参照列は draft を上書きしないため GC 温存の概念が不要). Always 48 elements.
   *
   * @generated from field: repeated bffuser.v1.SlotValue forecast_slots = 1;
   */
  forecastSlots: SlotValue[];
};

/**
 * Describes the message bffuser.v1.ConfirmRecordRetailPreviewResult.
 * Use `create(ConfirmRecordRetailPreviewResultSchema)` to create a new message.
 */
export const ConfirmRecordRetailPreviewResultSchema: GenMessage<ConfirmRecordRetailPreviewResult> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_demand_forecast_service, 30);

/**
 * BgPreviewResult carries the preview outcome for a BG_TOTAL scope
 * PreviewConfirmRecord operation, containing per-retailer results (AC-DFD-032
 * 内訳差分ハンドリング).
 *
 * @generated from message bffuser.v1.BgPreviewResult
 */
export type BgPreviewResult = Message<"bffuser.v1.BgPreviewResult"> & {
  /**
   * retailers carries the per-retailer preview outcomes for every
   * bg_retailer_business_cds entry with a matching confirm-batch record.
   *
   * @generated from field: repeated bffuser.v1.RetailerPreviewEntry retailers = 1;
   */
  retailers: RetailerPreviewEntry[];

  /**
   * missing_retailer_business_cds lists bg_retailer_business_cds entries with
   * no matching record in the confirm batch (現在いて確定時にいない retailer).
   * A bg_retailer_business_cds entry whose corresponding batch record exists
   * but is no longer under the current BG (確定時にいて現在いない) is simply
   * absent from both retailers and missing_retailer_business_cds (skip).
   *
   * @generated from field: repeated string missing_retailer_business_cds = 2;
   */
  missingRetailerBusinessCds: string[];
};

/**
 * Describes the message bffuser.v1.BgPreviewResult.
 * Use `create(BgPreviewResultSchema)` to create a new message.
 */
export const BgPreviewResultSchema: GenMessage<BgPreviewResult> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_demand_forecast_service, 31);

/**
 * PreviewConfirmRecordResponse carries the previewed (non-persisted,
 * draft-untouched) confirm-record values. Uses oneof to enforce RETAIL /
 * BG_TOTAL exclusivity at the wire level.
 *
 * @generated from message bffuser.v1.PreviewConfirmRecordResponse
 */
export type PreviewConfirmRecordResponse = Message<"bffuser.v1.PreviewConfirmRecordResponse"> & {
  /**
   * @generated from oneof bffuser.v1.PreviewConfirmRecordResponse.result
   */
  result: {
    /**
     * retail carries the single-retailer preview outcome (RETAIL scope).
     *
     * @generated from field: bffuser.v1.ConfirmRecordRetailPreviewResult retail = 1;
     */
    value: ConfirmRecordRetailPreviewResult;
    case: "retail";
  } | {
    /**
     * bg_total carries per-retailer preview outcomes (BG_TOTAL scope).
     *
     * @generated from field: bffuser.v1.BgPreviewResult bg_total = 2;
     */
    value: BgPreviewResult;
    case: "bgTotal";
  } | { case: undefined; value?: undefined };

  /**
   * label is the "確定 MM/DD" display label (frozen confirmed_at snapshot,
   * §6 機能詳細「確定日時のみ」簡素化ルール), shared by both scopes, used by the
   * frontend to render the reference column / chart series name.
   *
   * @generated from field: string label = 3;
   */
  label: string;
};

/**
 * Describes the message bffuser.v1.PreviewConfirmRecordResponse.
 * Use `create(PreviewConfirmRecordResponseSchema)` to create a new message.
 */
export const PreviewConfirmRecordResponseSchema: GenMessage<PreviewConfirmRecordResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_demand_forecast_service, 32);

/**
 * GetSimpleForecastEntryDefaultsRequest requests default source-date /
 * weight suggestions for the simple-forecast entry table (簡易予測入力).
 * organization_id is intentionally absent; the BFF handler resolves it from
 * the eauth session.
 *
 * @generated from message bffuser.v1.GetSimpleForecastEntryDefaultsRequest
 */
export type GetSimpleForecastEntryDefaultsRequest = Message<"bffuser.v1.GetSimpleForecastEntryDefaultsRequest"> & {
  /**
   * area_code identifies the electricity supply region. Must not be UNSPECIFIED.
   *
   * @generated from field: bfftypes.v1.AreaCode area_code = 1;
   */
  areaCode: AreaCode;

  /**
   * target_date is the forecast date for which defaults are derived.
   * Required.
   *
   * @generated from field: google.type.Date target_date = 2;
   */
  targetDate?: Date;

  /**
   * method is the simple-forecast derivation method. Must not be UNSPECIFIED.
   *
   * @generated from field: bffuser.v1.SimpleForecastMethod method = 3;
   */
  method: SimpleForecastMethod;

  /**
   * dates lists the source dates the operator has already selected in the
   * entry table. When empty, the backend derives its own default set of
   * source dates for the given method (初期表示). Maximum 30 dates (WMA の
   * source 日数上限; 実運用は 3-5 日程度).
   *
   * @generated from field: repeated google.type.Date dates = 4;
   */
  dates: Date[];

  /**
   * Optional case context. The new daily page supplies case_id and scope together.
   * Omitting all context fields preserves legacy area-only default selection.
   *
   * @generated from field: optional string case_id = 6;
   */
  caseId?: string;

  /**
   * @generated from field: optional bffuser.v1.AggregationScope scope = 7;
   */
  scope?: AggregationScope;

  /**
   * Retail scope requires its business code; BG_TOTAL omits it.
   *
   * @generated from field: optional string retailer_business_cd = 8;
   */
  retailerBusinessCd?: string;
};

/**
 * Describes the message bffuser.v1.GetSimpleForecastEntryDefaultsRequest.
 * Use `create(GetSimpleForecastEntryDefaultsRequestSchema)` to create a new message.
 */
export const GetSimpleForecastEntryDefaultsRequestSchema: GenMessage<GetSimpleForecastEntryDefaultsRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_demand_forecast_service, 33);

/**
 * GetSimpleForecastEntryDefaultsResponse carries the default source-date /
 * weight suggestions for the simple-forecast entry table.
 *
 * @generated from message bffuser.v1.GetSimpleForecastEntryDefaultsResponse
 */
export type GetSimpleForecastEntryDefaultsResponse = Message<"bffuser.v1.GetSimpleForecastEntryDefaultsResponse"> & {
  /**
   * entries lists the default source-date / weight suggestions, one per
   * requested (or backend-derived) source date. default_weight carries the
   * re-normalized weight when fewer than 3 source dates were secured for a
   * weighted-average method (simple-methods AC-006b).
   *
   * @generated from field: repeated bffuser.v1.SimpleForecastEntryDefault entries = 1;
   */
  entries: SimpleForecastEntryDefault[];

  /**
   * target_weekday_category is the target date's weekday category
   * (平日/土曜/日祝), used by the client to flag Entry rows whose
   * weekday_category does not match (行警告, simple-methods AC-006c). Always
   * populated, including on dates-specified re-resolution calls.
   *
   * @generated from field: bffuser.v1.WeekdayCategory target_weekday_category = 2;
   */
  targetWeekdayCategory: WeekdayCategory;

  /**
   * True only when defaults used the case's attributed breakdown actuals.
   * New clients must not consume a legacy response whose marker is false.
   *
   * @generated from field: bool per_breakdown_actuals = 4;
   */
  perBreakdownActuals: boolean;

  /**
   * target_singular_group mirrors internalapi.v1: the target date's
   * 特異グループ (1〜10), set only when its 需要扱い is 特異.
   *
   * @generated from field: optional int32 target_singular_group = 5;
   */
  targetSingularGroup?: number;
};

/**
 * Describes the message bffuser.v1.GetSimpleForecastEntryDefaultsResponse.
 * Use `create(GetSimpleForecastEntryDefaultsResponseSchema)` to create a new message.
 */
export const GetSimpleForecastEntryDefaultsResponseSchema: GenMessage<GetSimpleForecastEntryDefaultsResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_demand_forecast_service, 34);

/**
 * ListSimpleForecastUnavailableSourceDatesRequest mirrors
 * internalapi.v1.ListSimpleForecastUnavailableSourceDatesRequest without
 * organization_id (resolved from eauth).
 *
 * @generated from message bffuser.v1.ListSimpleForecastUnavailableSourceDatesRequest
 */
export type ListSimpleForecastUnavailableSourceDatesRequest = Message<"bffuser.v1.ListSimpleForecastUnavailableSourceDatesRequest"> & {
  /**
   * case_id is the WorkflowCase identifier (UUID).
   *
   * @generated from field: string case_id = 1;
   */
  caseId: string;

  /**
   * area_code identifies the electricity supply region. Must not be UNSPECIFIED.
   *
   * @generated from field: bfftypes.v1.AreaCode area_code = 2;
   */
  areaCode: AreaCode;

  /**
   * target_date is the forecast date. Required.
   *
   * @generated from field: google.type.Date target_date = 3;
   */
  targetDate?: Date;

  /**
   * method is the simple-forecast method. Must not be UNSPECIFIED.
   *
   * @generated from field: bffuser.v1.SimpleForecastMethod method = 4;
   */
  method: SimpleForecastMethod;

  /**
   * @generated from field: bffuser.v1.AggregationScope scope = 5;
   */
  scope: AggregationScope;

  /**
   * Retail scope requires its business code; BG_TOTAL omits it.
   *
   * @generated from field: optional string retailer_business_cd = 6;
   */
  retailerBusinessCd?: string;

  /**
   * from_date / to_date bound the range (inclusive, at most 42 days).
   *
   * @generated from field: google.type.Date from_date = 7;
   */
  fromDate?: Date;

  /**
   * @generated from field: google.type.Date to_date = 8;
   */
  toDate?: Date;
};

/**
 * Describes the message bffuser.v1.ListSimpleForecastUnavailableSourceDatesRequest.
 * Use `create(ListSimpleForecastUnavailableSourceDatesRequestSchema)` to create a new message.
 */
export const ListSimpleForecastUnavailableSourceDatesRequestSchema: GenMessage<ListSimpleForecastUnavailableSourceDatesRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_demand_forecast_service, 35);

/**
 * ListSimpleForecastUnavailableSourceDatesResponse carries the 実績の無い日 in
 * the requested range.
 *
 * @generated from message bffuser.v1.ListSimpleForecastUnavailableSourceDatesResponse
 */
export type ListSimpleForecastUnavailableSourceDatesResponse = Message<"bffuser.v1.ListSimpleForecastUnavailableSourceDatesResponse"> & {
  /**
   * @generated from field: repeated google.type.Date unavailable_dates = 1;
   */
  unavailableDates: Date[];
};

/**
 * Describes the message bffuser.v1.ListSimpleForecastUnavailableSourceDatesResponse.
 * Use `create(ListSimpleForecastUnavailableSourceDatesResponseSchema)` to create a new message.
 */
export const ListSimpleForecastUnavailableSourceDatesResponseSchema: GenMessage<ListSimpleForecastUnavailableSourceDatesResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_demand_forecast_service, 36);

/**
 * SimpleForecastEntryDefault is a single default suggestion row for the
 * simple-forecast entry table (簡易予測入力), pairing a source date with its
 * day-type classification and a backend-suggested weight. Mirrors
 * internalapi.v1.SimpleForecastEntryDefault; kept BFF-local to allow
 * independent evolution from the backend message.
 *
 * @generated from message bffuser.v1.SimpleForecastEntryDefault
 */
export type SimpleForecastEntryDefault = Message<"bffuser.v1.SimpleForecastEntryDefault"> & {
  /**
   * source_date is the calendar date used as a reference source.
   *
   * @generated from field: google.type.Date source_date = 1;
   */
  sourceDate?: Date;

  /**
   * weekday_category classifies the source date as weekday / Saturday /
   * holiday (平日 / 土曜 / 日祝).
   *
   * @generated from field: bffuser.v1.WeekdayCategory weekday_category = 2;
   */
  weekdayCategory: WeekdayCategory;

  /**
   * holiday_name is the Japanese public holiday name when the source date
   * is a public holiday. Empty string for non-holidays.
   *
   * @generated from field: string holiday_name = 3;
   */
  holidayName: string;

  /**
   * default_weight is the backend-suggested weight for this source date
   * (加重平均の重み初期値).
   *
   * @generated from field: google.type.Decimal default_weight = 4;
   */
  defaultWeight?: Decimal;

  /**
   * day_type is the source date's 日付種別 (AC-DFM-005a / 006c); a date
   * registered in the 特異日カレンダー master is SINGULAR.
   *
   * @generated from field: bffuser.v1.DayType day_type = 5;
   */
  dayType: DayType;

  /**
   * source_date_mismatch mirrors internalapi.v1 (AC-DFM-016).
   *
   * @generated from field: bffuser.v1.SimpleForecastSourceDateMismatch source_date_mismatch = 6;
   */
  sourceDateMismatch: SimpleForecastSourceDateMismatch;

  /**
   * actuals_missing is true when the source date is a 実績の無い日
   * (AC-DFM-014 / 017). The zero value never blocks import.
   *
   * @generated from field: bool actuals_missing = 7;
   */
  actualsMissing: boolean;

  /**
   * is_public_holiday is true for a public holiday (not for a plain Sunday).
   *
   * @generated from field: bool is_public_holiday = 8;
   */
  isPublicHoliday: boolean;
};

/**
 * Describes the message bffuser.v1.SimpleForecastEntryDefault.
 * Use `create(SimpleForecastEntryDefaultSchema)` to create a new message.
 */
export const SimpleForecastEntryDefaultSchema: GenMessage<SimpleForecastEntryDefault> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_demand_forecast_service, 37);

/**
 * SimpleForecastEntry is a single source-date / weight pair supplied by the
 * operator for weighted-average simple-forecast methods. Mirrors
 * internalapi.v1.SimpleForecastEntry; kept BFF-local to allow independent
 * evolution from the backend message.
 *
 * @generated from message bffuser.v1.SimpleForecastEntry
 */
export type SimpleForecastEntry = Message<"bffuser.v1.SimpleForecastEntry"> & {
  /**
   * source_date is the calendar date used as a reference source. Required.
   *
   * @generated from field: google.type.Date source_date = 1;
   */
  sourceDate?: Date;

  /**
   * weight is the operator-confirmed weight applied to this source date's
   * values in the weighted average. Required.
   *
   * @generated from field: google.type.Decimal weight = 2;
   */
  weight?: Decimal;
};

/**
 * Describes the message bffuser.v1.SimpleForecastEntry.
 * Use `create(SimpleForecastEntrySchema)` to create a new message.
 */
export const SimpleForecastEntrySchema: GenMessage<SimpleForecastEntry> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_demand_forecast_service, 38);

/**
 * PreviewSimpleForecastRequest computes attributed actuals for RETAIL or a supported BG_TOTAL client.
 *
 * @generated from message bffuser.v1.PreviewSimpleForecastRequest
 */
export type PreviewSimpleForecastRequest = Message<"bffuser.v1.PreviewSimpleForecastRequest"> & {
  /**
   * case_id is the WorkflowCase identifier (UUID).
   *
   * @generated from field: string case_id = 1;
   */
  caseId: string;

  /**
   * area_code identifies the electricity supply region. Must not be UNSPECIFIED.
   *
   * @generated from field: bfftypes.v1.AreaCode area_code = 2;
   */
  areaCode: AreaCode;

  /**
   * section is the planning horizon (断面). Must not be UNSPECIFIED.
   *
   * @generated from field: bffuser.v1.WorkflowSection section = 3;
   */
  section: WorkflowSection;

  /**
   * target_date is the forecast date. Required.
   *
   * @generated from field: google.type.Date target_date = 4;
   */
  targetDate?: Date;

  /**
   * @generated from field: optional string retailer_business_cd = 5;
   */
  retailerBusinessCd?: string;

  /**
   * method is the simple-forecast derivation method. Must not be UNSPECIFIED.
   *
   * @generated from field: bffuser.v1.SimpleForecastMethod method = 6;
   */
  method: SimpleForecastMethod;

  /**
   * entries lists the source-date / weight pairs.
   *
   * @generated from field: repeated bffuser.v1.SimpleForecastEntry entries = 7;
   */
  entries: SimpleForecastEntry[];

  /**
   * expected_updated_at / bg_targets from the former ImportSimpleForecastToDraftRequest
   * are intentionally absent: preview does not write, so no optimistic-lock
   * baseline is needed.
   *
   * @generated from field: bffuser.v1.AggregationScope scope = 8;
   */
  scope: AggregationScope;

  /**
   * The client can apply and retain an unattributed breakdown and missing-source notices.
   * Required for BG_TOTAL. Older retail clients cannot receive zeroed-breakdown results.
   *
   * @generated from field: bool supports_unattributed = 10;
   */
  supportsUnattributed: boolean;
};

/**
 * Describes the message bffuser.v1.PreviewSimpleForecastRequest.
 * Use `create(PreviewSimpleForecastRequestSchema)` to create a new message.
 */
export const PreviewSimpleForecastRequestSchema: GenMessage<PreviewSimpleForecastRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_demand_forecast_service, 39);

/**
 * PreviewSimpleForecastResponse carries non-persisted per-breakdown forecasts.
 *
 * @generated from message bffuser.v1.PreviewSimpleForecastResponse
 */
export type PreviewSimpleForecastResponse = Message<"bffuser.v1.PreviewSimpleForecastResponse"> & {
  /**
   * @generated from oneof bffuser.v1.PreviewSimpleForecastResponse.result
   */
  result: {
    /**
     * @generated from field: bffuser.v1.RetailPreviewResult retail = 1;
     */
    value: RetailPreviewResult;
    case: "retail";
  } | {
    /**
     * @generated from field: bffuser.v1.BgTotalPreviewResult bg_total = 2;
     */
    value: BgTotalPreviewResult;
    case: "bgTotal";
  } | { case: undefined; value?: undefined };

  /**
   * Source dates used by every returned breakdown, in calculation order.
   *
   * @generated from field: repeated google.type.Date source_dates = 3;
   */
  sourceDates: Date[];

  /**
   * Retailers missing actuals on every source date and overwritten with zero.
   * Unattributed demand is never included.
   *
   * @generated from field: repeated string zeroed_retailer_business_cds = 4;
   */
  zeroedRetailerBusinessCds: string[];

  /**
   * New clients apply results only when this marker is true.
   *
   * @generated from field: bool per_breakdown_actuals = 5;
   */
  perBreakdownActuals: boolean;
};

/**
 * Describes the message bffuser.v1.PreviewSimpleForecastResponse.
 * Use `create(PreviewSimpleForecastResponseSchema)` to create a new message.
 */
export const PreviewSimpleForecastResponseSchema: GenMessage<PreviewSimpleForecastResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_demand_forecast_service, 40);

/**
 * RetailPreviewResult carries the previewed (non-persisted) simple-forecast
 * derivation outcome for RETAIL scope (no write happened; the optimistic-lock
 * baseline is unchanged and the trend banner stays draft-based until the next
 * save).
 *
 * @generated from message bffuser.v1.RetailPreviewResult
 */
export type RetailPreviewResult = Message<"bffuser.v1.RetailPreviewResult"> & {
  /**
   * forecast_slots contains the previewed demand forecast values (GC 温存
   * merge 済み: komas at or before the gate-closed koma keep the existing
   * draft's value). Always 48 elements.
   *
   * @generated from field: repeated bffuser.v1.SlotValue forecast_slots = 1;
   */
  forecastSlots: SlotValue[];

  /**
   * provider_slots contains the provider-sourced values before manual edits
   * (取り込み原値, unmerged). Always 48 elements.
   *
   * @generated from field: repeated bffuser.v1.SlotValue provider_slots = 2;
   */
  providerSlots: SlotValue[];

  /**
   * provider is the data source classification.
   *
   * @generated from field: bffuser.v1.DemandForecastProvider provider = 3;
   */
  provider: DemandForecastProvider;

  /**
   * provider_label is a frozen display name snapshot of the provider.
   *
   * @generated from field: optional string provider_label = 4;
   */
  providerLabel?: string;

  /**
   * provider_other records the simple forecast method when provider is OTHER.
   *
   * @generated from field: optional string provider_other = 5;
   */
  providerOther?: string;
};

/**
 * Describes the message bffuser.v1.RetailPreviewResult.
 * Use `create(RetailPreviewResultSchema)` to create a new message.
 */
export const RetailPreviewResultSchema: GenMessage<RetailPreviewResult> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_demand_forecast_service, 41);

/**
 * BgTotalPreviewResult carries each retailer and the BG unattributed breakdown.
 *
 * @generated from message bffuser.v1.BgTotalPreviewResult
 */
export type BgTotalPreviewResult = Message<"bffuser.v1.BgTotalPreviewResult"> & {
  /**
   * bg_results carries per-retailer preview outcomes.
   *
   * @generated from field: repeated bffuser.v1.RetailerPreviewResult bg_results = 1;
   */
  bgResults: RetailerPreviewResult[];

  /**
   * @generated from field: bffuser.v1.DemandForecastProvider provider = 2;
   */
  provider: DemandForecastProvider;

  /**
   * provider_label is a frozen display name snapshot of the method, shared
   * by every retailer. Mirrors RetailPreviewResult.provider_label.
   *
   * @generated from field: optional string provider_label = 3;
   */
  providerLabel?: string;

  /**
   * Always present for a supported BG_TOTAL response, including an all-zero result.
   *
   * @generated from field: bffuser.v1.UnattributedPreviewResult unattributed = 4;
   */
  unattributed?: UnattributedPreviewResult;

  /**
   * provider_other records the method shared by all breakdowns.
   *
   * @generated from field: optional string provider_other = 5;
   */
  providerOther?: string;
};

/**
 * Describes the message bffuser.v1.BgTotalPreviewResult.
 * Use `create(BgTotalPreviewResultSchema)` to create a new message.
 */
export const BgTotalPreviewResultSchema: GenMessage<BgTotalPreviewResult> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_demand_forecast_service, 42);

/**
 * UnattributedPreviewResult carries the BG's separate unattributed preview values.
 * It has no retailer identifier; preview does not persist either series.
 *
 * @generated from message bffuser.v1.UnattributedPreviewResult
 */
export type UnattributedPreviewResult = Message<"bffuser.v1.UnattributedPreviewResult"> & {
  /**
   * Forecast values after preserving gate-closed slots from the current draft.
   *
   * @generated from field: repeated bffuser.v1.SlotValue forecast_slots = 1;
   */
  forecastSlots: SlotValue[];

  /**
   * Provider values before gate-closure merging.
   *
   * @generated from field: repeated bffuser.v1.SlotValue provider_slots = 2;
   */
  providerSlots: SlotValue[];
};

/**
 * Describes the message bffuser.v1.UnattributedPreviewResult.
 * Use `create(UnattributedPreviewResultSchema)` to create a new message.
 */
export const UnattributedPreviewResultSchema: GenMessage<UnattributedPreviewResult> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_demand_forecast_service, 43);

/**
 * RetailerPreviewResult carries one retailer's previewed (non-persisted)
 * simple-forecast derivation outcome for BG_TOTAL scope (no write happened).
 *
 * @generated from message bffuser.v1.RetailerPreviewResult
 */
export type RetailerPreviewResult = Message<"bffuser.v1.RetailerPreviewResult"> & {
  /**
   * retailer_business_cd identifies the retailer (4-char OCCTO business code).
   *
   * @generated from field: string retailer_business_cd = 1;
   */
  retailerBusinessCd: string;

  /**
   * forecast_slots contains the previewed demand forecast values for this
   * retailer (GC 温存 merge 済み). Always 48 elements.
   *
   * @generated from field: repeated bffuser.v1.SlotValue forecast_slots = 2;
   */
  forecastSlots: SlotValue[];

  /**
   * provider_slots contains this retailer's provider-sourced values before
   * manual edits (取り込み原値: 内訳別実績からの計算値・GC merge 前, unmerged; scale:
   * see SlotValue doc). Always 48 elements.
   *
   * @generated from field: repeated bffuser.v1.SlotValue provider_slots = 3;
   */
  providerSlots: SlotValue[];
};

/**
 * Describes the message bffuser.v1.RetailerPreviewResult.
 * Use `create(RetailerPreviewResultSchema)` to create a new message.
 */
export const RetailerPreviewResultSchema: GenMessage<RetailerPreviewResult> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_demand_forecast_service, 44);

/**
 * PreviewTrendReflectionRequest identifies the (case, area, target_date) to
 * re-preview the trend reflection for, with a caller-supplied aggregation
 * window (集計窓, demand-trend-window-variable design Contract).
 *
 * @generated from message bffuser.v1.PreviewTrendReflectionRequest
 */
export type PreviewTrendReflectionRequest = Message<"bffuser.v1.PreviewTrendReflectionRequest"> & {
  /**
   * case_id is the WorkflowCase identifier (UUID).
   *
   * @generated from field: string case_id = 1;
   */
  caseId: string;

  /**
   * area_code identifies the electricity supply region. Must not be UNSPECIFIED.
   *
   * @generated from field: bfftypes.v1.AreaCode area_code = 2;
   */
  areaCode: AreaCode;

  /**
   * target_date is the forecast date. Required.
   *
   * @generated from field: google.type.Date target_date = 3;
   */
  targetDate?: Date;

  /**
   * aggregation_window_koma is the number of recent pre-GC komas to average
   * over (集計窓, spec AC-DFD-009a: 既定 3h = 6 コマ、0.5〜12h = 1〜24 コマ、
   * 1 コマ = 0.5h).
   *
   * @generated from field: int32 aggregation_window_koma = 4;
   */
  aggregationWindowKoma: number;

  /**
   * retailer_plan_slots is the live, per-retailer plan basis for the
   * correction (demand-trend-reflection-single-authority design D2/D5):
   * empty (default) means "use the saved draft" (window-only re-preview
   * hook, unchanged existing behavior); present means the backend computes
   * avg_ratio and the corrected series against THESE values instead of the
   * saved draft — the trend-reflect dialog passes the operator's
   * in-progress, unsaved editRow values here so "表示される補正後 BG 合計 ==
   * Apply 後に保存される BG 合計" holds even when the operator has not saved
   * yet (spec AC-DFD-012 決定 A: V_plan = 編集中の値、手動編集を破棄しない).
   * The caller is expected to pass every case-BG retailer's live plan (no
   * server-side partial fallback for missing entries).
   *
   * Client contract (trusted, not enforced): the set MUST equal the case-BG
   * retailer set exactly — no duplicate, missing, or out-of-scope
   * retailer_business_cd. The backend intentionally does NOT re-resolve scope
   * on the live path and does NOT validate the set, so an incomplete/
   * mismatched set silently breaks the "表示 == 保存" invariant. Keeping parity
   * is the caller's responsibility; server-side enforcement is a deferred
   * follow-up.
   *
   * @generated from field: repeated bffuser.v1.RetailerPlanSlots retailer_plan_slots = 5;
   */
  retailerPlanSlots: RetailerPlanSlots[];
};

/**
 * Describes the message bffuser.v1.PreviewTrendReflectionRequest.
 * Use `create(PreviewTrendReflectionRequestSchema)` to create a new message.
 */
export const PreviewTrendReflectionRequestSchema: GenMessage<PreviewTrendReflectionRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_demand_forecast_service, 45);

/**
 * RetailerPlanSlots is one retailer's per-koma plan input
 * (PreviewTrendReflectionRequest.retailer_plan_slots). Mirrors
 * internalapi.v1.RetailerPlanSlots; kept BFF-local.
 *
 * @generated from message bffuser.v1.RetailerPlanSlots
 */
export type RetailerPlanSlots = Message<"bffuser.v1.RetailerPlanSlots"> & {
  /**
   * retailer_business_cd is the retailer's 4-char OCCTO business code, the
   * same identity used as the demand forecast draft's RETAIL-scope
   * scope_identifier.
   *
   * @generated from field: string retailer_business_cd = 1;
   */
  retailerBusinessCd: string;

  /**
   * plan_slots is this retailer's live per-koma plan (V_plan), the
   * correction's multiplication basis. Always 48 elements.
   *
   * @generated from field: repeated bffuser.v1.SlotValue plan_slots = 2;
   */
  planSlots: SlotValue[];
};

/**
 * Describes the message bffuser.v1.RetailerPlanSlots.
 * Use `create(RetailerPlanSlotsSchema)` to create a new message.
 */
export const RetailerPlanSlotsSchema: GenMessage<RetailerPlanSlots> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_demand_forecast_service, 46);

/**
 * PreviewTrendReflectionResponse carries the recomputed trend reflection
 * preview.
 *
 * @generated from message bffuser.v1.PreviewTrendReflectionResponse
 */
export type PreviewTrendReflectionResponse = Message<"bffuser.v1.PreviewTrendReflectionResponse"> & {
  /**
   * trend_preview is the recomputed trend reflection preview. Absent when GC
   * has not started for the target date (date gate), when fewer than 2 present
   * actual komas exist for the target date (Gate A, independent of the
   * requested window), or when the requested window contains no valid
   * plan/actual pair (Gate B) (= バッジ非表示相当, spec §4). Note W=1 (minimum
   * window) still returns a preview when Gate A holds and that single koma is a
   * valid pair.
   *
   * @generated from field: optional bffuser.v1.TrendReflectionPreview trend_preview = 1;
   */
  trendPreview?: TrendReflectionPreview;
};

/**
 * Describes the message bffuser.v1.PreviewTrendReflectionResponse.
 * Use `create(PreviewTrendReflectionResponseSchema)` to create a new message.
 */
export const PreviewTrendReflectionResponseSchema: GenMessage<PreviewTrendReflectionResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_demand_forecast_service, 47);

/**
 * DayType classifies the target date into one of four categories for the
 * date-type display feature (spec §8, AC-036): 平日 / 土曜 / 休日（日祝）/
 * 特異日. Mirrors internalapi.v1.DayType; kept BFF-local to allow independent
 * evolution from the backend enum. Distinct from WeekdayCategory (3-category,
 * used by similar-day search filtering only). Judgement priority: SINGULAR >
 * HOLIDAY > SATURDAY > WEEKDAY (a public holiday is 休日 whatever weekday it
 * falls on — see internalapi.v1.DayType godoc).
 *
 * @generated from enum bffuser.v1.DayType
 */
export enum DayType {
  /**
   * @generated from enum value: DAY_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * DAY_TYPE_WEEKDAY is a weekday (平日).
   *
   * @generated from enum value: DAY_TYPE_WEEKDAY = 1;
   */
  WEEKDAY = 1,

  /**
   * DAY_TYPE_SATURDAY is a Saturday (土曜, not a public holiday).
   *
   * @generated from enum value: DAY_TYPE_SATURDAY = 2;
   */
  SATURDAY = 2,

  /**
   * DAY_TYPE_HOLIDAY is a Sunday or public holiday (休日: 日曜 or 祝日,
   * including 振替休日 and a public holiday falling on a Saturday).
   *
   * @generated from enum value: DAY_TYPE_HOLIDAY = 3;
   */
  HOLIDAY = 3,

  /**
   * DAY_TYPE_SINGULAR is a day registered in the singular_day master (特異日).
   *
   * @generated from enum value: DAY_TYPE_SINGULAR = 4;
   */
  SINGULAR = 4,
}

/**
 * Describes the enum bffuser.v1.DayType.
 */
export const DayTypeSchema: GenEnum<DayType> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_demand_forecast_service, 0);

/**
 * DemandForecastProvider classifies the data source used to derive the
 * demand forecast slots (需要予測手法 / プロバイダ). Mirrors
 * internalapi.v1.DemandForecastProvider; kept BFF-local to allow independent
 * evolution from the backend enum.
 *
 * @generated from enum bffuser.v1.DemandForecastProvider
 */
export enum DemandForecastProvider {
  /**
   * @generated from enum value: DEMAND_FORECAST_PROVIDER_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * DEMAND_FORECAST_PROVIDER_SYSTEM_AUTO is a system-generated automatic
   * forecast (システム自動).
   *
   * @generated from enum value: DEMAND_FORECAST_PROVIDER_SYSTEM_AUTO = 1;
   */
  SYSTEM_AUTO = 1,

  /**
   * DEMAND_FORECAST_PROVIDER_MANUAL_INPUT is a fully manual entry by the
   * operator (手動入力).
   *
   * @generated from enum value: DEMAND_FORECAST_PROVIDER_MANUAL_INPUT = 2;
   */
  MANUAL_INPUT = 2,

  /**
   * DEMAND_FORECAST_PROVIDER_PRIOR_YEAR_ACTUAL uses the corresponding
   * slot values from the prior-year actual (前年実績).
   *
   * @generated from enum value: DEMAND_FORECAST_PROVIDER_PRIOR_YEAR_ACTUAL = 3;
   */
  PRIOR_YEAR_ACTUAL = 3,

  /**
   * DEMAND_FORECAST_PROVIDER_CURVE_BASED is a temperature-demand regression
   * curve estimation (回帰曲線).
   *
   * @generated from enum value: DEMAND_FORECAST_PROVIDER_CURVE_BASED = 4;
   */
  CURVE_BASED = 4,

  /**
   * DEMAND_FORECAST_PROVIDER_DATA_VENDOR is a forecast supplied by an
   * external data vendor (外部データプロバイダ).
   *
   * @generated from enum value: DEMAND_FORECAST_PROVIDER_DATA_VENDOR = 5;
   */
  DATA_VENDOR = 5,

  /**
   * DEMAND_FORECAST_PROVIDER_OTHER is any provider not covered by the
   * above values. When set, provider_other and provider_label should be
   * populated.
   *
   * @generated from enum value: DEMAND_FORECAST_PROVIDER_OTHER = 6;
   */
  OTHER = 6,
}

/**
 * Describes the enum bffuser.v1.DemandForecastProvider.
 */
export const DemandForecastProviderSchema: GenEnum<DemandForecastProvider> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_demand_forecast_service, 1);

/**
 * SimpleForecastMethod classifies the derivation method used by the
 * simple-forecast import feature (簡易予測取込): copy from a single
 * reference day, or a weighted average across several reference days.
 * Mirrors internalapi.v1.SimpleForecastMethod; kept BFF-local to allow
 * independent evolution from the backend enum.
 *
 * @generated from enum bffuser.v1.SimpleForecastMethod
 */
export enum SimpleForecastMethod {
  /**
   * @generated from enum value: SIMPLE_FORECAST_METHOD_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * SIMPLE_FORECAST_METHOD_PREV_DAY_COPY copies the previous day's actual
   * values as-is (前日実績コピー).
   *
   * @generated from enum value: SIMPLE_FORECAST_METHOD_PREV_DAY_COPY = 1;
   */
  PREV_DAY_COPY = 1,

  /**
   * SIMPLE_FORECAST_METHOD_SAME_WEEKDAY_CATEGORY_PREV_WEEK_COPY copies the
   * most recent reference day sharing the target date's weekday category
   * (平日/土曜/日祝), searched 7〜60 days prior; none found aborts the
   * target date (同区分前週コピー, AC-DFM-004 / AC-DFM-015).
   *
   * @generated from enum value: SIMPLE_FORECAST_METHOD_SAME_WEEKDAY_CATEGORY_PREV_WEEK_COPY = 2;
   */
  SAME_WEEKDAY_CATEGORY_PREV_WEEK_COPY = 2,

  /**
   * SIMPLE_FORECAST_METHOD_WEIGHTED_MOVING_AVG computes a weighted average
   * across operator-selected reference days (加重移動平均).
   *
   * @generated from enum value: SIMPLE_FORECAST_METHOD_WEIGHTED_MOVING_AVG = 3;
   */
  WEIGHTED_MOVING_AVG = 3,

  /**
   * SIMPLE_FORECAST_METHOD_SAME_WEEKDAY_CATEGORY_WEIGHTED_AVG computes a
   * weighted average across operator-selected reference days sharing the
   * same weekday category (同区分加重平均).
   *
   * @generated from enum value: SIMPLE_FORECAST_METHOD_SAME_WEEKDAY_CATEGORY_WEIGHTED_AVG = 4;
   */
  SAME_WEEKDAY_CATEGORY_WEIGHTED_AVG = 4,

  /**
   * SIMPLE_FORECAST_METHOD_UPPER_SECTION_COPY copies the saved forecast
   * value from the next-coarser planning section as-is (上位断面コピー,
   * simple-methods §2-6 AC-DFM-012). Applicable sections: 単日 (all target
   * dates 当日/翌日/翌々日, upper section = 週間) + 週間 (upper section = 月間)
   * + 月間 (upper section = 年間, P1). Not applicable to 年間 (top of the
   * hierarchy).
   *
   * @generated from enum value: SIMPLE_FORECAST_METHOD_UPPER_SECTION_COPY = 5;
   */
  UPPER_SECTION_COPY = 5,
}

/**
 * Describes the enum bffuser.v1.SimpleForecastMethod.
 */
export const SimpleForecastMethodSchema: GenEnum<SimpleForecastMethod> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_demand_forecast_service, 2);

/**
 * AuxiliaryDataStatus represents the fetch result for a single auxiliary data
 * source (weather / provider forecast / past actuals). Mirrors
 * internalapi.v1.AuxiliaryDataStatus; kept BFF-local to allow independent
 * evolution from the backend enum. Absent (= unset) fields indicate the status
 * is unknown; callers should treat them the same as
 * AUXILIARY_DATA_STATUS_UNSPECIFIED.
 *
 * @generated from enum bffuser.v1.AuxiliaryDataStatus
 */
export enum AuxiliaryDataStatus {
  /**
   * @generated from enum value: AUXILIARY_DATA_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * AUXILIARY_DATA_STATUS_OK means the auxiliary data was fetched successfully.
   *
   * @generated from enum value: AUXILIARY_DATA_STATUS_OK = 1;
   */
  OK = 1,

  /**
   * AUXILIARY_DATA_STATUS_FETCH_FAILED means the auxiliary data fetch failed;
   * the corresponding data field in the page will be absent or empty.
   *
   * @generated from enum value: AUXILIARY_DATA_STATUS_FETCH_FAILED = 2;
   */
  FETCH_FAILED = 2,
}

/**
 * Describes the enum bffuser.v1.AuxiliaryDataStatus.
 */
export const AuxiliaryDataStatusSchema: GenEnum<AuxiliaryDataStatus> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_demand_forecast_service, 3);

/**
 * DemandForecastConfirmErrorReason mirrors
 * internalapi.v1.DemandForecastConfirmErrorReason (see its comment for the
 * full contract). The backend emits the internalapi enum's value name as
 * google.rpc.ErrorInfo.reason and the frontend resolves it against this
 * mirror's generated TS enum, so the two must declare the exact same value
 * names (pinned by adapter/grpc/interceptor/error_reason_mirror_test.go).
 *
 * @generated from enum bffuser.v1.DemandForecastConfirmErrorReason
 */
export enum DemandForecastConfirmErrorReason {
  /**
   * @generated from enum value: DEMAND_FORECAST_CONFIRM_ERROR_REASON_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 需要想定値が未入力のコマが残っている (全コマ必須, 確定の前提未充足)。
   *
   * @generated from enum value: DEMAND_FORECAST_CONFIRM_ERROR_REASON_SLOT_NOT_FILLED = 1;
   */
  SLOT_NOT_FILLED = 1,

  /**
   * 確定対象の draft が保存されていない (save-then-confirm ordering)。
   *
   * @generated from enum value: DEMAND_FORECAST_CONFIRM_ERROR_REASON_DRAFT_NOT_SAVED = 2;
   */
  DRAFT_NOT_SAVED = 2,

  /**
   * ケースが編集不可 = 需要想定が確定済み (AC-DFC-007)、 または
   * WorkflowCase が COMPLETE / DELETED。
   *
   * @generated from enum value: DEMAND_FORECAST_CONFIRM_ERROR_REASON_CASE_NOT_EDITABLE = 3;
   */
  CASE_NOT_EDITABLE = 3,

  /**
   * GC 以降のコマの値が 1 コマの上限 (999,999,999 kWh/30min) を超えている
   * (AC-DFC-EDIT-004 / AC-DFC-006d)。 metadata: koma (1〜48)、 value (整形しない
   * decimal 文字列)、 retailerBusinessCd。
   *
   * @generated from enum value: DEMAND_FORECAST_CONFIRM_ERROR_REASON_SLOT_VALUE_OVER_LIMIT = 4;
   */
  SLOT_VALUE_OVER_LIMIT = 4,

  /**
   * GC 以降のコマの BG 全体の合計 (確定する全事業者の合計) が上限を超えている
   * (AC-DFC-EDIT-004 / AC-DFC-006d)。 metadata: koma (1〜48)、 value (合計、 整形しない
   * decimal 文字列)。
   *
   * @generated from enum value: DEMAND_FORECAST_CONFIRM_ERROR_REASON_BG_TOTAL_OVER_LIMIT = 5;
   */
  BG_TOTAL_OVER_LIMIT = 5,

  /**
   * @generated from enum value: DEMAND_FORECAST_CONFIRM_ERROR_REASON_UNATTRIBUTED_REMAINING = 6;
   */
  UNATTRIBUTED_REMAINING = 6,
}

/**
 * Describes the enum bffuser.v1.DemandForecastConfirmErrorReason.
 */
export const DemandForecastConfirmErrorReasonSchema: GenEnum<DemandForecastConfirmErrorReason> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_demand_forecast_service, 4);

/**
 * DemandForecastGetErrorReason mirrors internalapi.v1.DemandForecastGetErrorReason.
 *
 * @generated from enum bffuser.v1.DemandForecastGetErrorReason
 */
export enum DemandForecastGetErrorReason {
  /**
   * @generated from enum value: DEMAND_FORECAST_GET_ERROR_REASON_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: DEMAND_FORECAST_GET_ERROR_REASON_CLIENT_UPDATE_REQUIRED = 1;
   */
  CLIENT_UPDATE_REQUIRED = 1,
}

/**
 * Describes the enum bffuser.v1.DemandForecastGetErrorReason.
 */
export const DemandForecastGetErrorReasonSchema: GenEnum<DemandForecastGetErrorReason> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_demand_forecast_service, 5);

/**
 * DemandForecastSaveErrorReason mirrors
 * internalapi.v1.DemandForecastSaveErrorReason (see its comment for the full
 * contract). The backend emits the internalapi enum's value name as
 * google.rpc.ErrorInfo.reason and the frontend resolves it against this
 * mirror's generated TS enum, so the two must declare the exact same value
 * names (pinned by adapter/grpc/interceptor/error_reason_mirror_test.go).
 *
 * @generated from enum bffuser.v1.DemandForecastSaveErrorReason
 */
export enum DemandForecastSaveErrorReason {
  /**
   * @generated from enum value: DEMAND_FORECAST_SAVE_ERROR_REASON_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * ケースが編集不可 = 需要想定が確定済み (AC-DFC-007)、 または WorkflowCase が
   * COMPLETE / DELETED (AC-WFW-014)。
   *
   * @generated from enum value: DEMAND_FORECAST_SAVE_ERROR_REASON_CASE_NOT_EDITABLE = 1;
   */
  CASE_NOT_EDITABLE = 1,

  /**
   * @generated from enum value: DEMAND_FORECAST_SAVE_ERROR_REASON_CLIENT_UPDATE_REQUIRED = 2;
   */
  CLIENT_UPDATE_REQUIRED = 2,
}

/**
 * Describes the enum bffuser.v1.DemandForecastSaveErrorReason.
 */
export const DemandForecastSaveErrorReasonSchema: GenEnum<DemandForecastSaveErrorReason> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_demand_forecast_service, 6);

/**
 * DemandForecastSimpleForecastPreviewErrorReason mirrors
 * internalapi.v1.DemandForecastSimpleForecastPreviewErrorReason (see its
 * comment for the full contract, including the ④ AC-DFM-011 exclusion).
 * Pinned by adapter/grpc/interceptor/error_reason_mirror_test.go.
 *
 * @generated from enum bffuser.v1.DemandForecastSimpleForecastPreviewErrorReason
 */
export enum DemandForecastSimpleForecastPreviewErrorReason {
  /**
   * @generated from enum value: DEMAND_FORECAST_SIMPLE_FORECAST_PREVIEW_ERROR_REASON_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * ケースが編集不可 = 需要想定が確定済み (AC-DFC-007)、 または WorkflowCase が
   * COMPLETE / DELETED (AC-WFW-014)。
   *
   * @generated from enum value: DEMAND_FORECAST_SIMPLE_FORECAST_PREVIEW_ERROR_REASON_CASE_NOT_EDITABLE = 1;
   */
  CASE_NOT_EDITABLE = 1,

  /**
   * 上位断面コピーの取込元となる上位断面の保存済み需要想定値が存在しない
   * (AC-DFM-013)。
   *
   * @generated from enum value: DEMAND_FORECAST_SIMPLE_FORECAST_PREVIEW_ERROR_REASON_UPPER_SECTION_COPY_SOURCE_NOT_FOUND = 2;
   */
  UPPER_SECTION_COPY_SOURCE_NOT_FOUND = 2,

  /**
   * 選択した手法に必要な実績データが不足している (AC-DFM-008)。
   *
   * @generated from enum value: DEMAND_FORECAST_SIMPLE_FORECAST_PREVIEW_ERROR_REASON_INSUFFICIENT_ACTUAL_DATA = 3;
   */
  INSUFFICIENT_ACTUAL_DATA = 3,

  /**
   * 対象日が需要扱い「特異」で、 同一特異グループの過去特異日が 21〜400 日前の窓に
   * 1 件も見つからない (同区分前週コピー, AC-DFM-006a-1)。 enum 名の
   * SINGULAR_CATEGORY は比較キーを特異グループへ切り替える前の名残で、 wire 互換のため維持する。
   *
   * @generated from enum value: DEMAND_FORECAST_SIMPLE_FORECAST_PREVIEW_ERROR_REASON_INSUFFICIENT_SOURCE_CANDIDATES_SINGULAR_CATEGORY = 4;
   */
  INSUFFICIENT_SOURCE_CANDIDATES_SINGULAR_CATEGORY = 4,

  /**
   * 同区分前週コピーで、 特異グループの日と実績の無い日を除いた 7〜60 日前に取得元の日が
   * 見つからない (AC-DFM-015)。
   *
   * @generated from enum value: DEMAND_FORECAST_SIMPLE_FORECAST_PREVIEW_ERROR_REASON_INSUFFICIENT_SOURCE_CANDIDATES_AFTER_SINGULAR_EXCLUSION = 5;
   */
  INSUFFICIENT_SOURCE_CANDIDATES_AFTER_SINGULAR_EXCLUSION = 5,

  /**
   * The client cannot safely apply the returned breakdowns or missing-source notice.
   *
   * @generated from enum value: DEMAND_FORECAST_SIMPLE_FORECAST_PREVIEW_ERROR_REASON_CLIENT_UPDATE_REQUIRED = 6;
   */
  CLIENT_UPDATE_REQUIRED = 6,
}

/**
 * Describes the enum bffuser.v1.DemandForecastSimpleForecastPreviewErrorReason.
 */
export const DemandForecastSimpleForecastPreviewErrorReasonSchema: GenEnum<DemandForecastSimpleForecastPreviewErrorReason> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_demand_forecast_service, 7);

/**
 * DemandForecastSimpleForecastEntryDefaultsErrorReason mirrors
 * internalapi.v1.DemandForecastSimpleForecastEntryDefaultsErrorReason.
 *
 * @generated from enum bffuser.v1.DemandForecastSimpleForecastEntryDefaultsErrorReason
 */
export enum DemandForecastSimpleForecastEntryDefaultsErrorReason {
  /**
   * @generated from enum value: DEMAND_FORECAST_SIMPLE_FORECAST_ENTRY_DEFAULTS_ERROR_REASON_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: DEMAND_FORECAST_SIMPLE_FORECAST_ENTRY_DEFAULTS_ERROR_REASON_UPPER_SECTION_COPY_SOURCE_NOT_FOUND = 1;
   */
  UPPER_SECTION_COPY_SOURCE_NOT_FOUND = 1,

  /**
   * @generated from enum value: DEMAND_FORECAST_SIMPLE_FORECAST_ENTRY_DEFAULTS_ERROR_REASON_INSUFFICIENT_SOURCE_CANDIDATES_SINGULAR_CATEGORY = 2;
   */
  INSUFFICIENT_SOURCE_CANDIDATES_SINGULAR_CATEGORY = 2,

  /**
   * @generated from enum value: DEMAND_FORECAST_SIMPLE_FORECAST_ENTRY_DEFAULTS_ERROR_REASON_INSUFFICIENT_SOURCE_CANDIDATES_AFTER_SINGULAR_EXCLUSION = 3;
   */
  INSUFFICIENT_SOURCE_CANDIDATES_AFTER_SINGULAR_EXCLUSION = 3,
}

/**
 * Describes the enum bffuser.v1.DemandForecastSimpleForecastEntryDefaultsErrorReason.
 */
export const DemandForecastSimpleForecastEntryDefaultsErrorReasonSchema: GenEnum<DemandForecastSimpleForecastEntryDefaultsErrorReason> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_demand_forecast_service, 8);

/**
 * DemandForecastConfirmRecordPreviewErrorReason mirrors
 * internalapi.v1.DemandForecastConfirmRecordPreviewErrorReason (see its
 * comment for the full contract). Pinned by
 * adapter/grpc/interceptor/error_reason_mirror_test.go.
 *
 * @generated from enum bffuser.v1.DemandForecastConfirmRecordPreviewErrorReason
 */
export enum DemandForecastConfirmRecordPreviewErrorReason {
  /**
   * @generated from enum value: DEMAND_FORECAST_CONFIRM_RECORD_PREVIEW_ERROR_REASON_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * ケースが編集不可 = 需要想定が確定済み (AC-DFC-007)、 または WorkflowCase が
   * COMPLETE / DELETED (AC-WFW-014)。
   *
   * @generated from enum value: DEMAND_FORECAST_CONFIRM_RECORD_PREVIEW_ERROR_REASON_CASE_NOT_EDITABLE = 1;
   */
  CASE_NOT_EDITABLE = 1,

  /**
   * BG_TOTAL scope で bg_retailer_business_cds のどの retailer も確定バッチに
   * マッチしない (表示対象の小売が 0 件、AC-DFD-032)。
   *
   * @generated from enum value: DEMAND_FORECAST_CONFIRM_RECORD_PREVIEW_ERROR_REASON_NO_MATCHING_RETAILERS = 2;
   */
  NO_MATCHING_RETAILERS = 2,
}

/**
 * Describes the enum bffuser.v1.DemandForecastConfirmRecordPreviewErrorReason.
 */
export const DemandForecastConfirmRecordPreviewErrorReasonSchema: GenEnum<DemandForecastConfirmRecordPreviewErrorReason> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_demand_forecast_service, 9);

/**
 * WeekdayCategory classifies the day type for similar-day search
 * (平日 / 土曜 / 日祝). Mirrors internalapi.v1.WeekdayCategory; kept
 * BFF-local to allow independent evolution from the backend enum.
 *
 * @generated from enum bffuser.v1.WeekdayCategory
 */
export enum WeekdayCategory {
  /**
   * @generated from enum value: WEEKDAY_CATEGORY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * WEEKDAY_CATEGORY_WEEKDAY is a weekday (平日, Monday–Friday excluding
   * holidays).
   *
   * @generated from enum value: WEEKDAY_CATEGORY_WEEKDAY = 1;
   */
  WEEKDAY = 1,

  /**
   * WEEKDAY_CATEGORY_SATURDAY is a Saturday (土曜).
   *
   * @generated from enum value: WEEKDAY_CATEGORY_SATURDAY = 2;
   */
  SATURDAY = 2,

  /**
   * WEEKDAY_CATEGORY_HOLIDAY is a Sunday or public holiday
   * (日祝: 日曜 or 祝日).
   *
   * @generated from enum value: WEEKDAY_CATEGORY_HOLIDAY = 3;
   */
  HOLIDAY = 3,
}

/**
 * Describes the enum bffuser.v1.WeekdayCategory.
 */
export const WeekdayCategorySchema: GenEnum<WeekdayCategory> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_demand_forecast_service, 10);

/**
 * WeatherCategory is the daily-representative weather bucket (概況 4 分類).
 * Mirrors internalapi.v1.WeatherCategory; kept BFF-local to allow independent
 * evolution from the backend enum. UNSPECIFIED は「その過去日の天気実績なし」を
 * 表す正当値 (not_in: [0] は付けない)。
 *
 * @generated from enum bffuser.v1.WeatherCategory
 */
export enum WeatherCategory {
  /**
   * @generated from enum value: WEATHER_CATEGORY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: WEATHER_CATEGORY_SUNNY = 1;
   */
  SUNNY = 1,

  /**
   * @generated from enum value: WEATHER_CATEGORY_CLOUDY = 2;
   */
  CLOUDY = 2,

  /**
   * @generated from enum value: WEATHER_CATEGORY_RAINY = 3;
   */
  RAINY = 3,

  /**
   * @generated from enum value: WEATHER_CATEGORY_SNOWY = 4;
   */
  SNOWY = 4,
}

/**
 * Describes the enum bffuser.v1.WeatherCategory.
 */
export const WeatherCategorySchema: GenEnum<WeatherCategory> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_demand_forecast_service, 11);

/**
 * SimpleForecastSourceDateMismatch mirrors
 * internalapi.v1.SimpleForecastSourceDateMismatch (simple-methods
 * AC-DFM-016). UNSPECIFIED means "not judged" and must not be read as NONE.
 *
 * @generated from enum bffuser.v1.SimpleForecastSourceDateMismatch
 */
export enum SimpleForecastSourceDateMismatch {
  /**
   * @generated from enum value: SIMPLE_FORECAST_SOURCE_DATE_MISMATCH_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SIMPLE_FORECAST_SOURCE_DATE_MISMATCH_NONE = 1;
   */
  NONE = 1,

  /**
   * @generated from enum value: SIMPLE_FORECAST_SOURCE_DATE_MISMATCH_NOT_SAME_SINGULAR_GROUP = 2;
   */
  NOT_SAME_SINGULAR_GROUP = 2,

  /**
   * @generated from enum value: SIMPLE_FORECAST_SOURCE_DATE_MISMATCH_SINGULAR_GROUP_DAY = 3;
   */
  SINGULAR_GROUP_DAY = 3,

  /**
   * @generated from enum value: SIMPLE_FORECAST_SOURCE_DATE_MISMATCH_DAY_CATEGORY = 4;
   */
  DAY_CATEGORY = 4,
}

/**
 * Describes the enum bffuser.v1.SimpleForecastSourceDateMismatch.
 */
export const SimpleForecastSourceDateMismatchSchema: GenEnum<SimpleForecastSourceDateMismatch> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_demand_forecast_service, 12);

/**
 * DemandForecastService provides Connect RPCs for the demand forecast daily
 * editing workflow (需要想定 daily 編集画面). It covers three operations:
 *   - Get:      retrieve the aggregated page for a given (case, area, section,
 *               target_date), containing all retailer drafts + BG-total +
 *               comparison series in a single response;
 *   - SaveDraft: persist the operator's edits for a single retailer (identified
 *               by retailer_business_cd) as a draft;
 *   - Confirm:  batch-freeze all retailer drafts for the given context as
 *               business-confirmed records.
 *
 * @generated from service bffuser.v1.DemandForecastService
 */
export const DemandForecastService: GenService<{
  /**
   * GetDemandForecastDaily returns the aggregated editing page for the given
   * (case_id, area_code, section, target_date). The page contains all retailer
   * drafts under the case, the read-only BG-total slot series, past actuals,
   * confirm-record baselines, and weather data. For the TODAY section, a
   * retailer with no saved draft is seeded from its confirmed history
   * (前日確定値). For TOMORROW / DAY_AFTER_TOMORROW, a retailer with no saved
   * draft returns empty slots (未入力).
   *
   * @generated from rpc bffuser.v1.DemandForecastService.GetDemandForecastDaily
   */
  getDemandForecastDaily: {
    methodKind: "unary";
    input: typeof GetDemandForecastDailyRequestSchema;
    output: typeof GetDemandForecastDailyResponseSchema;
  },
  /**
   * SaveDemandForecastDraft persists the operator's 48-slot edits for a single
   * retailer (identified by retailer_business_cd) as a draft (明示「保存」操作). Uses
   * optimistic locking via expected_updated_at; omit on the first save.
   *
   * @generated from rpc bffuser.v1.DemandForecastService.SaveDemandForecastDraft
   */
  saveDemandForecastDraft: {
    methodKind: "unary";
    input: typeof SaveDemandForecastDraftRequestSchema;
    output: typeof SaveDemandForecastDraftResponseSchema;
  },
  /**
   * ConfirmDemandForecast batch-freezes the saved drafts for all specified
   * retailers as business-confirmed demand records (業務確定). Uses per-retailer
   * optimistic locking via targets[].expected_updated_at (required per target).
   *
   * @generated from rpc bffuser.v1.DemandForecastService.ConfirmDemandForecast
   */
  confirmDemandForecast: {
    methodKind: "unary";
    input: typeof ConfirmDemandForecastRequestSchema;
    output: typeof ConfirmDemandForecastResponseSchema;
  },
  /**
   * SearchSimilarDays searches for past days that are similar to the given
   * target_date within the specified lookback window, ranked by similarity
   * score (S(d), lower = more similar). Used by the similar-day selection
   * dialog (類似日検索ダイアログ). organization_id is intentionally absent;
   * the BFF handler resolves it from the eauth session.
   *
   * @generated from rpc bffuser.v1.DemandForecastService.SearchSimilarDays
   */
  searchSimilarDays: {
    methodKind: "unary";
    input: typeof SearchSimilarDaysRequestSchema;
    output: typeof SearchSimilarDaysResponseSchema;
  },
  /**
   * RecordSimilarDayPicks records which similar-day candidates the operator
   * selected ("applied"). Fire-and-forget; failure does not block UI apply.
   * organization_id is intentionally absent; the BFF handler resolves it
   * from the eauth session.
   *
   * @generated from rpc bffuser.v1.DemandForecastService.RecordSimilarDayPicks
   */
  recordSimilarDayPicks: {
    methodKind: "unary";
    input: typeof RecordSimilarDayPicksRequestSchema;
    output: typeof RecordSimilarDayPicksResponseSchema;
  },
  /**
   * PreviewConfirmRecord previews a previously confirmed demand record
   * (DemandConfirmRecord) as a non-destructive reference column (確定履歴の
   * 参照列プレビュー, s07-confirm-history-import-reference-view.md) WITHOUT
   * touching the draft. The client applies the result as an additional
   * reference column/series alongside the editable draft (過去実績と同挙動);
   * persistence of the editable draft continues to happen only via
   * SaveDemandForecastDraft. The BFF determines scope (RETAIL or BG_TOTAL)
   * from the request and forwards to the internalapi. organization_id is
   * resolved from eauth.
   *
   * @generated from rpc bffuser.v1.DemandForecastService.PreviewConfirmRecord
   */
  previewConfirmRecord: {
    methodKind: "unary";
    input: typeof PreviewConfirmRecordRequestSchema;
    output: typeof PreviewConfirmRecordResponseSchema;
  },
  /**
   * GetSimpleForecastEntryDefaults returns default source-date / weight
   * suggestions for the simple-forecast entry table (簡易予測入力), given the
   * selected derivation method. When dates is empty, the backend derives its
   * own default set of source dates. organization_id is intentionally
   * absent; the BFF handler resolves it from the eauth session.
   *
   * @generated from rpc bffuser.v1.DemandForecastService.GetSimpleForecastEntryDefaults
   */
  getSimpleForecastEntryDefaults: {
    methodKind: "unary";
    input: typeof GetSimpleForecastEntryDefaultsRequestSchema;
    output: typeof GetSimpleForecastEntryDefaultsResponseSchema;
  },
  /**
   * ListSimpleForecastUnavailableSourceDates returns the 実績の無い日
   * (simple-methods AC-DFM-014 / 017) in [from_date, to_date] for the
   * settings dialog's date picker. organization_id is resolved from the eauth
   * session.
   *
   * @generated from rpc bffuser.v1.DemandForecastService.ListSimpleForecastUnavailableSourceDates
   */
  listSimpleForecastUnavailableSourceDates: {
    methodKind: "unary";
    input: typeof ListSimpleForecastUnavailableSourceDatesRequestSchema;
    output: typeof ListSimpleForecastUnavailableSourceDatesResponseSchema;
  },
  /**
   * PreviewSimpleForecast derives forecast slots using the given simple-forecast
   * method (簡易予測取込のプレビュー) WITHOUT persisting anything. The client
   * applies the result to its unsaved edit buffer; persistence happens only via
   * SaveDemandForecastDraft (明示保存). GC-passed komas are merged from the
   * existing draft server-side (same merge as the former import RPC).
   * organization_id is intentionally absent; resolved from eauth.
   * scope MUST be RETAIL: BG_TOTAL is rejected by the backend with
   * InvalidArgument because 需要想定値の投入単位は小売事業者のみ (spec
   * demand-forecast-daily.md AC-DFD-033/033a, 2026-08-12 決定).
   *
   * @generated from rpc bffuser.v1.DemandForecastService.PreviewSimpleForecast
   */
  previewSimpleForecast: {
    methodKind: "unary";
    input: typeof PreviewSimpleForecastRequestSchema;
    output: typeof PreviewSimpleForecastResponseSchema;
  },
  /**
   * PreviewTrendReflection recomputes the trend reflection preview (avgRatio +
   * GC以降補正) for the same-day section using a caller-supplied aggregation
   * window (集計窓, spec AC-DFD-009a). WITHOUT persisting anything. organization_id
   * is intentionally absent; resolved from eauth.
   *
   * @generated from rpc bffuser.v1.DemandForecastService.PreviewTrendReflection
   */
  previewTrendReflection: {
    methodKind: "unary";
    input: typeof PreviewTrendReflectionRequestSchema;
    output: typeof PreviewTrendReflectionResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_bffuser_v1_demand_forecast_service, 0);

